var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuriken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 2000",
    width: 500,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(996,203)",
    d: "m0 0 4 2 6 36 6 39 16 97 6 30 3 13v64l4 42 5 29 5 22 6 20 9 20 8 14 8 11 9 10 7 4 3 1h10l19-4 26-9 17-8 16-10 11-9 20-18 12-11 10-9 10-10 7-8 5-6h2l2-4 12-12 7-8 15-16 7-8 15-16 7-8 30-32 7-8h2l2-4 24-24 7-8 5-5h2v-2l8-7 5-4h2l-1 6-12 23-11 23-9 20-8 16-10 17-14 24-15 29-14 26-12 22-14 25-17 34-10 23-9 25-7 25-3 13-1 9-1 28 2 7 9 9 17 12 14 8 15 6 27 7 36 6 20 2 32 1 28-1 33-4 25-4 23-6 24-9 2-1h14l50 4 78 5 54 2 18 2v3l-16 5-38 9-26 8-29 11-64 23-42 15-17 5-18 2-33 2-22 3-39 8-32 9-42 15-26 12-16 9-12 8-14 11-13 12-12 14-7 14v21l5 27 8 24 14 35 18 39 16 33 15 26 24 40 15 23 11 17 12 19 11 17 12 21 15 28 11 17 1 6-5-2-10-8-15-14-30-27-11-9-16-15-8-7-8-8-8-7-44-44-8-7-31-31-8-7-14-12-10-9-11-9-16-12-16-9-14-6-23-6-9-1h-16l-7 3-8 6-10 14-8 14-10 21-12 36-7 28-7 35-5 33-4 36-2 33v41l1 12v29l-4 25-7 36-13 67-6 32-4 31-4 16-4 1-2-5-13-77-13-70-8-40-4-25v-11l1-9 1-42-1-29-4-51-6-41-6-31-8-32-11-33-9-20-7-12-6-7v-2l-4-2-10-8-5-2-9-1-20 2-17 5-15 6-18 10-16 11-14 11-26 22-13 12-15 14-22 22-7 8-42 42-8 7-8 8-8 7-10 9-11 9-16 15-11 9-15 13-9 7h-3l3-9 6-12 8-11 15-23 15-24 12-19 7-11 15-23 13-22 9-14 17-28 12-22 15-29 11-25 7-15 10-24 8-25 6-26 3-16v-7l-3-10-9-12-11-12-11-9-15-11-22-13-16-9-19-9-35-13-25-8-36-9-26-5-22-3-41-1-27-10-18-7-42-15-37-13-42-14-42-12-22-7-1-2 6-1 79-4 99-7 30-3 24 10 21 7 29 5 36 4h62l25-3 25-4 26-7 21-9 21-12 12-9 5-4 4-6 1-4v-15l-3-19-9-31-7-20-9-21-15-30-12-22-16-31-12-22-25-45-12-22-14-27-15-32-15-34-8-12 1-4 10 9 34 34 7 8 11 11 7 8 9 9 7 8 9 9 7 8 7 7 7 8 12 13 7 8 11 12 9 10 11 12 7 8 28 28 8 7 15 13 15 11 14 8 19 8 25 7 26 5 10-5 7-6 10-14 9-17 8-21 6-21 7-34 7-49 1-12v-43l-2-8 1-13 7-37 9-50 12-68 4-24 4-31zm-188 502-1 5h-2v-2h-2l2 9 9 15 9 11 11 12 8 8 11 9 14 11 15 9 8 4 11 3 7 1h10l10-3 6-4 3-3-1-4-6-19-6-11-7-8-15-11-19-9-22-6-36-8-7-4-6-5zm-6 1 1 2zm388 7-11 3-45 8-21 6-12 5-11 7-13 11-8 11-7 14-3 10 4 6 10 5 7 2h9l16-4 9-4 18-10 13-10 15-13 13-13 9-13 10-19v-2zm-382 111-14 3-21 8-19 12-10 8-8 8-6 12-1 7 5 7h2v2l12 8 14 5 12 2h21l15-3 17-6 18-10 17-11 7-6 3-5v-10l-5-10-9-8-19-9-10-3-7-1zm369 0-16 4-18 8-12 11-8 9-2 3 1 5 7 8 16 11 18 10 10 5 19 6 6 1h22l12-4 16-8 11-9 4-7-2-9-7-10-9-9-10-7-14-8-17-7-11-3zm-189 35-11 4-11 8-7 7-5 8-4 14v19l3 11 10 10 13 8 8 3 9 2 12-1 13-5 14-10 10-10 3-7 1-5v-13l-5-14-7-12-7-7-10-6-11-4zm110 153-13 2-8 4-7 6-5 10v16l4 15 7 16 7 9 8 4 12 2 43 3 28 2 15 3-1-5-12-20-12-17-12-14-9-10-4-5-8-7-10-7-10-5zm-203 2-13 4-14 9-13 11-7 7-7 8-12 15-11 16-11 19v2l6-1 13-2 63-6 13-2 10-6 9-10 7-14 3-15v-16l-5-10-7-6-8-3z",
    fill: "#1D1E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(996,203)",
    d: "m0 0 4 2 6 36 6 39 16 97 6 30 3 13v64l4 42 5 29 5 22 6 20 9 20 8 14 8 11 9 10 7 4 3 1h10l19-4 26-9 17-8 16-10 11-9 20-18 12-11 10-9 10-10 7-8 5-6h2l2-4 12-12 7-8 15-16 7-8 15-16 7-8 30-32 7-8h2l2-4 24-24 7-8 5-5h2v-2l8-7 5-4h2l-1 6-12 23-11 23-9 20-8 16-10 17-14 24-15 29-14 26-12 22-14 25-17 34-10 23-9 25-7 25-3 13-1 9-1 28 2 7 9 9 17 12 14 8 15 6 27 7 36 6 20 2 32 1 28-1 33-4 25-4 23-6 24-9 2-1h14l50 4 78 5 54 2 18 2v3l-6 2h-47l-32 3-52 8-85 17-40 7-73 10-104 12-30 5-24 7-21 8-26 11-22 7-40 10-21 5-22 2-14-1-10-3-6-4-3-5 6 2 7 3 13 2h12l19-3 12-4 9-4 2-1-5-1-18 2h-24l-22-3-7-3 1-2 15 1h35l26-2 2-1-10-5-5-2-9-6-11-7-13-9h-4-6l-10-4v-2l-1 1h-14l-22-3-7-3-12-18-15-13-7-8-4-10-5-43-6-25-10-27-8-19 11 32 7 18 4 13v17l-4 5h-2l-2 4-9 4-12 1-13-2-10-5-2-5v-19l5-16 10-27 3-15 1-10v-17l-4 23-8 27-5 15-6 22-7 34-4 17-2 10-5 7-10 8-7 8-10 14-8 3-9 2h-19l-15 3-1 3h-2v2l-10 6-4 2 4 2 3 1-19 8-12 4h-4v-2l-3 1 1 5 2 1 20 2h26l21-2 1 4-19 4-8 1-44 1 4 3 16 5 12 2h23l13-4 6-2 1 3-12 6-8 2h-28l-26-5-30-7-24-6-20-7-27-14-9-4-3-2h-8l-9-3-31-5-11-2-41-4-70-9-70-10-47-9-45-9-35-6-43-6-36-3h-38l-9-3-1-2 6-1 79-4 99-7 30-3 24 10 21 7 29 5 36 4h62l25-3 25-4 26-7 21-9 21-12 12-9 5-4 4-6 1-4v-15l-3-19-9-31-7-20-9-21-15-30-12-22-16-31-12-22-25-45-12-22-14-27-15-32-15-34-8-12 1-4 10 9 34 34 7 8 11 11 7 8 9 9 7 8 9 9 7 8 7 7 7 8 12 13 7 8 11 12 9 10 11 12 7 8 28 28 8 7 15 13 15 11 14 8 19 8 25 7 26 5 10-5 7-6 10-14 9-17 8-21 6-21 7-34 7-49 1-12v-43l-2-8 1-13 7-37 9-50 12-68 4-24 4-31zm-188 502-1 5h-2v-2h-2l2 9 9 15 9 11 11 12 8 8 11 9 14 11 15 9 8 4 11 3 7 1h10l10-3 6-4 3-3-1-4-6-19-6-11-7-8-15-11-19-9-22-6-36-8-7-4-6-5zm-6 1 1 2zm388 7-11 3-45 8-21 6-12 5-11 7-13 11-8 11-7 14-3 10 4 6 10 5 7 2h9l16-4 9-4 18-10 13-10 15-13 13-13 9-13 10-19v-2zm-382 111-14 3-21 8-19 12-10 8-8 8-6 12-1 7 5 7h2v2l12 8 14 5 12 2h21l15-3 17-6 18-10 17-11 7-6 3-5v-10l-5-10-9-8-19-9-10-3-7-1zm369 0-16 4-18 8-12 11-8 9-2 3 1 5 7 8 16 11 18 10 10 5 19 6 6 1h22l12-4 16-8 11-9 4-7-2-9-7-10-9-9-10-7-14-8-17-7-11-3z",
    fill: "#FAF9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(572,389)",
    d: "m0 0 6 4 39 39 7 8 11 11 7 8 9 9 7 8 9 9 7 8 7 7 7 8 12 13 7 8 11 12 9 10 11 12 7 8 28 28 8 7 15 13 15 11 14 8 19 8 25 7 26 5 10-5 7-6 10-14 9-17 8-21 6-21 7-34 7-49 1-12v-45l2-13 3-13 2-9 3-7h3l3 1-1 7 2 4 1 10v3l-1 10-1 2 2 1-1 8v6l2 2-3 12 3 9v9l-1 1v6h2v3h3l4 7 2 5 2 6v63l-1 51v51l2 14v5h-1l-4 23-8 27-5 15-6 22-7 34-4 17-2 10-5 7-10 8-7 8-10 14-8 3-9 2h-19l-15 3-1 3h-2v2l-10 6-4 2 4 2 3 1-19 8-12 4h-4v-2l-3 1 1 5 2 1 20 2h26l21-2 1 4-19 4-8 1-44 1 4 3 16 5 12 2h23l13-4 6-2 1 3-12 6-8 2h-28l-26-5-30-7-24-6-20-7-27-14-9-4-3-2h-8l-9-3-31-5-11-2-41-4-70-9-70-10-47-9-45-9-35-6-43-6-36-3h-38l-9-3-1-2 6-1 79-4 99-7 30-3 24 10 21 7 29 5 36 4h62l25-3 25-4 26-7 21-9 21-12 12-9 5-4 4-6 1-4v-15l-3-19-9-31-7-20-9-21-15-30-12-22-16-31-12-22-25-45-12-22-14-27-15-32-15-34-8-12zm236 316-1 5h-2v-2h-2l2 9 9 15 9 11 11 12 8 8 11 9 14 11 15 9 8 4 11 3 7 1h10l10-3 6-4 3-3-1-4-6-19-6-11-7-8-15-11-19-9-22-6-36-8-7-4-6-5zm-6 1 1 2zm6 118-14 3-21 8-19 12-10 8-8 8-6 12-1 7 5 7h2v2l12 8 14 5 12 2h21l15-3 17-6 18-10 17-11 7-6 3-5v-10l-5-10-9-8-19-9-10-3-7-1z",
    fill: "#F9F9F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1725,827)",
    d: "m0 0h47l-3 2-56 14-20 7-35 13-55 20-26 9-27 9-10 2-45 3-22 3-39 8-32 9-42 15-26 12-16 9-12 8-14 11-13 12-12 14-7 14v21l5 27 8 24 14 35 18 39 16 33 15 26 24 40 15 23 11 17 12 19 11 17 12 21 15 28 11 17 1 6-5-2-10-8-15-14-30-27-11-9-16-15-8-7-8-8-8-7-44-44-8-7-31-31-8-7-14-12-10-9-11-9-16-12-16-9-14-6-23-6-9-1h-18l-4-10-8-17-3-14 4-4 10-2 1-3-24-3v-5h-2v-2l2-2 4-3 1-4 18 1 50 3 21 3 3 1 2-2 4 5 2 5 1 4 3 4 3 1v3h-3v4l-5-1-1-2 1-2-11 1v3l5 4 10 4 2 5 9 3v2h5l2-1-4-6h-4l-1-4h2l1-2v2l4 1-5-11-3-7-3-9-4-18-2-18-3-14-2-13-3-12-4-9-8-19-7-11-5-6-3-2v-2l-4-2-18-13-10-6-9-3-8-2-6 1-9 6-4-1 7-7h2l-1-2h-10l-8 7-12 10-13 9-5 4-5 6v-3l2-4v-3l13-10 3-3h2v-2h2v-3l-4 3-5 2-7 5h-2v2l-7 4-6 2-6-2v2l-5 1v2h-2l-1-6 2-7v-6h2l-2-4v-5l2 1v4l24-11 17-10 10-7 6-8 3-6 2-14 1-5h3v2l5 1 2 8v4l10 1v1h-9l2 2 16 3 10 1h24l22-2 2 2-7 4-13 5-14 3-9 1h-12l-13-2-10-4-2-1 4 5 10 4 4 1 15 1 21-2 25-6 40-10 23-8 31-13 27-9 25-5 29-4 96-11 71-10 44-8 55-11 26-5 46-7z",
    fill: "#1D1E23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(990,685)",
    d: "m0 0 2 3v17l-3 21-5 15-9 24-2 8v19l2 5 9 4 13 2 12-1 10-5 6-7v-17l-9-27-6-15-7-21 1-2 6 13 13 35 6 25 5 43 4 10 10 11 11 9 7 10 5 7v2l12 3 17 2h13l4-2 1 2h-3l1 2 9 3h7 3l10 7 14 9 9 6 12 5 5 4-14 2-16 1h-35l-16-3-3-12-4-1v-2h-3l-1 9-2 13-7 10-7 6-26 15-13 6-7 2-1-4 1 8-1 1-1 7-1 11h2v-2l5-1v-2h5l3 1 7-4 4-1v-2l9-6 6-3 3-1v3h-2v2l-10 8-8 6-3 5-7 10-7 16h-2l-2 9h-2l-3 10-6 18-7 34-4 20-3 11-2-1v-9l-2-17-7-1-3-8-4-14-7-36-4-17-3-8v-4h-2l-1-3-2-1v-4l-3-1-2-9-3-1 1 5 6 14 4 12 7 29 4 21 2 24 2 11-2 6-3-1-3-12-5-33-5-21-7-24-10-28-1-4 4-7 3-4 2-1-3-3 5-1-13-7-18-14-16-9-6-7-5-7-1-11 1-3-5-1-2 6-2 4-22 3h-26l-20-2-3-2v-5l-2-1h5v2l24-8 8-4-5-2 1-2 11-6 3-1v-2l5-4 13-3h19l15-4 5-5 8-12 9-9 7-5 5-8 3-16 8-38 5-20 6-19 7-23 4-17zm-2 174-11 4-11 8-7 7-5 8-4 14v19l3 11 10 10 13 8 8 3 9 2 12-1 13-5 14-10 10-10 3-7 1-5v-13l-5-14-7-12-7-7-10-6-11-4z",
    fill: "#040304"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1257,784)",
    d: "m0 0 4 2 7 7 17 12 14 8 15 6 27 7 36 6 20 2 32 1 28-1 33-4 25-4 23-6 24-9 2-1h14l50 4 78 5 54 2 18 2v3l-6 2h-47l-32 3-52 8-85 17-40 7-73 10-104 12-30 5-24 7-21 8-26 11-22 7-40 10-21 5-22 2-14-1-10-3-6-4-3-5 6 2 7 3 13 2h12l19-3 12-4 9-4 2-1-5-1-18 2h-24l-22-3-7-3 1-2 15 1h35l26-2 2-1-10-5-5-2-9-6-11-7-13-9-9-8-3-3v-2h-2l-2-3v5h-2v2l-5 2h-14l-13-2-2-1 1-5-1-3 4 1 7 3h10l6-4-3-7-2-6-2-7 2-4 2-7 5-1 1 1 2 11 3-4 2 17 6 9 7 6 15 10 18 10 19 7 13 3h22l12-4 16-8 10-8 3-5 2-1 3-10v-9l-4-11-9-10-12-10-10-7-19-12-2-1v-2l25-11 21-10z",
    fill: "#FAF9F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1420,398)",
    d: "m0 0 1 2-15 30-13 29-8 16-15 26-10 17-15 29-14 26-12 22-14 25-17 34-10 23-9 25-7 25-3 13-1 9-1 28 1 7-8 5-26 12-12 5h-2v2l5 2 18 11 14 11 12 11 5 7 3 9v9l-3 10-2 1-1-8-4-8-9-10-11-9-16-9-17-7-11-3h-16l-16 4-18 8-12 11-7 8-4 5-2-7-1-19 3-10 7-9 9-11 11-12 9-10 14-14 7-8 5-5 4-3 1 2 6-8 3-9-1-2 6-15 12-35 8-16 7-11 13-19 13-17 8-11 9-12 11-13 13-16 13-17 14-19 24-34 13-18 10-15 14-19 13-18 10-15 10-14z",
    fill: "#1F2025"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,391)",
    d: "m0 0 5 2-1 7 2 4 1 10v3l-1 10-1 2 2 1-1 8v6l2 2-3 12 3 9v9l-1 1v6h2v3h3l4 7 2 5 2 6v63l-1 51v51l2 14v5h-1l-1 5h-1v-23h-2l-2 9-4 11-3 7-7 3-3 7-5 15-2 9-3 7-4 1-1 2-2-2-1-7-4-1-7-8 6 8 7 11 3 11v9l-3 13-9 13-9 7-2-1 4-4-1-4-6-19-6-11-6-7-15-11-19-9-22-6-36-8-7-4-6-5h-4l-1 4h-2v-2h-2l1 6-3-4-9-25-4-9 1-2 13 9 12 5 28 6 44 7 16 4 3 1-5-12-6-26-1-9 12-6 7-6 10-14 9-17 8-21 6-21 7-34 7-49 1-12v-45l2-13 3-13 2-9 3-7zm-169 315 1 2z",
    fill: "#A6A6A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,405)",
    d: "m0 0 5 5 11 18 10 16 17 28 9 15 11 19 12 21 15 29 12 21 3 6 5 9 7 12 6 12 4 7v2l6-2-1 9 1 3 4-3 3 7 3 3v2l4 2 3 3 4 7 10 9 13 1 3-1 3-8 6 2 8 11 6 12 3 9-1 2h2l11 39 6 25 2-1 8 6 5 5 4 5 3-3h-2l1-2 7 6 3 4v2l4 2 12 12 14 19 10 13 3 8-3 21-3 10h-1l-2-12-6-9-8-6-17-8-10-3-7-1h-14l-14 3-21 8-19 12-10 8-7 7-6 12-2 6-4-4-1-3v-9l4-10 12-15 14-11 17-13 16-9 1-2-5-1-17-7-21-10-3-5 2-6v-15l-3-19-9-31-7-20-9-21-15-30-12-22-16-31-12-22-25-45-12-22-14-27-15-32-14-32z",
    fill: "#060506"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1093,953)",
    d: "m0 0h10l1 3-8 7 5-1 9-6 6 1 8 2 8 3 12 7 19 14 5 5 8 11 6 12 9 21 4 16 3 19 2 15 4 22 3 11 3 5 5 12 1 3-6-2v4l2 1 1-2 4 5-1 4-6-1v-2l-7-2-4-4-1-2-10-4-6-5 2-3 12-1-1 4 5 1v-2l-2-2 5 1v-3l-4-1-2-4-3-1h2l-4-9-6-7-11-19-12-17-12-14-9-10-3-3v-2l-4-2-9-8-10-6-10-3-8-1-13 2-8 4-6 5-5 10v16l4 15 7 16 6 8 8 4 5 2-1 5-1 3-5 1v2h2v5l15 1 15 2v1h-6l-1 3-12 3-1 4 4 15 8 15 2 5v4l-9 6-5 5-8 10-2 4-5 2 1-4 8-12 7-9 4-1-3-7-4 1-7 7h-3l2-5 5-9-2-6-5-7-5-3v-8l-6 4-9 9-7 8-10 12-10 15-3 6h-2l-2 5-3 4-4 8-4 4-4 8-6 21h-2v-13l3-21 5-22 5-17 7-19 8-17 3-5 25-8 15-4 1-2-14 3-9 2h-10l-2-1v-2h-2l-5-11-3-14v-19l3-14 5-13 6-10 8-8 12-7 15-6 8-2h-2v-2l-5-1-2-2-11-2v-4l6-8 3-2-1-1-7 3-14 1-7 6-6 9-8 16-4 9-5 13-3 7-4-1 8-24 3-10 9-17 7-6 5-5 9-7 12-9 12-11z",
    fill: "#040304"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1423,389)",
    d: "m0 0h2l-1 6-5 5-8 10-19 28-14 19-12 17-11 16-14 19-13 19-14 19-12 16-8 10-13 16-11 13-10 14-13 17-12 17-12 18-8 16-4 10h-4l-3 3-2-2 1-8 3-9-9 6-18 6-34 7-36 7-16 4 3-9 9-32 2-8-2-1 25-5 26-9 17-8 16-10 11-9 20-18 12-11 10-9 10-10 7-8 5-6h2l2-4 12-12 7-8 15-16 7-8 15-16 7-8 30-32 7-8h2l2-4 24-24 7-8 5-5h2v-2l8-7z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,368)",
    d: "m0 0 2 1 4 13 2 10 7 29 1 2 3 1v60l4 42 5 29 5 22 6 20 9 20 8 14 8 11 9 10 7 4 9 3-2 11-9 32-2 5 19-5 53-10 20-5 13-5 8-5-1 5-10 27-5 12h-2l2-6 1-2-8 3-50 9-21 6-12 5-11 7-13 11-7 10-7 14-3 10 1 4-8-6-7-8-6-11-1-4v-13l4-10 6-9 5-6 12-9 8-5 11-3-3-5-7-5v-2h-2l-9-11-8-8-10-6-9-6-6-6v-6h-2l2-6 4-6 8-7 12-7h2v-3l-3-1-7-17v-2l-3-1-4-8v-2h-2v2l-6 1v-3l-1 2-5-1-1 3 3 7-3 1-3-5-4-3v-8l-3-8h-2l1 24-2-3-3-14v-28l1-12 3-5h2l2-12 2-7h-3l-1-8 1-2v-9l-1-11-1-5h2v-40l1-8-1-5v-40l-1-3 1-12v-1l1-10z",
    fill: "#A6A6A2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(572,389)",
    d: "m0 0 6 4 39 39 7 8 11 11 7 8 9 9 7 8 9 9 7 8 7 7 7 8 12 13 7 8 11 12 9 10 11 12 7 8 28 28 8 7 15 13 15 11 14 8 19 8 25 7 24 5 6 28 5 16 1 4-9-2-34-6-30-5-21-5-14-7-9-6-2-4-2-5-4-1-6-8-5-4-5-7v-2l-3-1-6-8-7-9-5-3-12-16-14-17-13-15-14-18-13-18-24-34-8-11-8-12-2-2-3-5-8-15-7-10 3 6-1 3-5-8-2-1-1 2-11-18-12-19-6-9-4-4-6-9z",
    fill: "#FBFBFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(996,203)",
    d: "m0 0 4 2 6 36 6 39 16 97 6 30 3 13-1 4-4-1-2-10-5-21-3-13-3-10-1 4-1 6 1 4h-1l-1 12 1 1v44l1 4-1 10-1 35h-2l2 6 1 10v9l-1 5 2 3 2 4-3 10-1 8-4 1-1 3-1 12-2 1v-34h-2l-2-8-2-2 1-3-1-1v-6l-4-6-2 9-2 11-3 92h-1v-110l-4-10-3-4v-3h-3v-3h-2l-1-7h2l-1-9-3-10 2-5 1-6-2-2v-10l1-4-1-3 1-10v-3l-1-11-2-4 1-6-4-1-3 7-2 9-3 13-2 13-2-2-1-10 4-24 7-36 13-74 8-46 5-37z",
    fill: "#FBF5EA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(889,959)",
    d: "m0 0h19l13 4 12 8 4 5-1 2-5-1-5-4 1 7 4 2 2 6-5-1v-2h-2v-2h-2v-2l-4-2-4-10-1-3-6-1-2-1v3l3-1 7 11 1 5h2l4 7-1 4-8-6-3-2 2-2-4-4-2-1-4-8-4-1 2 4 7 9 1 5 6 8 2 2-1 2h-5l-13-6-1 2 2 1v4l5 2 16 6 11 7 8 7 7 9 5 14 1 8v20l-1 13-3 11h-2l-1 6-2 5-2 2-9-1-17-5-6-3v-2l-4-1-1 5-4-1v-3-5l11-7 8-9 7-14 3-15v-16l-5-10-8-6-6-2h-16l-13 4-14 9-13 11-15 16-12 16-9 13-11 19-3 5-4 10-3 3h-2l-2 5-10 10-3 1-2 4-5 3v-3l1-3 5-5 6-10 4-10 4-13 9-35 2-13 1-16-2-2-5-1v-7l3-7h5l1 5 3-3 3-7 5-10 2-6h2l2-5 11-9 12-7h3v-2l12-7 8-3h3v-2l9-3z",
    fill: "#040304"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1564,810)",
    d: "m0 0h14l50 4 78 5 54 2 18 2v3l-6 2h-47l-32 3-52 8-85 17-40 7-73 10-17 2h-10v-2l-4-1-16-1-20-2-2-1 2-4 11-7 8-7 8-4 11-3 15-2 40-2 26-5 17-5 8-3 11-4 18-6z",
    fill: "#FAF3E8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(743,1032)",
    d: "m0 0 3 1 1 9 1 5 3 1 2 8 3 2 2 8v7l5 5 1 5 4 4 2 9 3 5v8l-2 4-1 5-2 5h-2l1 3-5 5-3 5-3 3-4 7-3 4-3 7h-2l-1 3h-2l-1 4-4 5-2 3-5 3-2 6-6 4-2 4h-2l-2 5-2 4-4 4-5 9-7 11-3 7-4 5-4 6-10 13-14 19-9 11-10 12-1 2h-2l-1 4-4 4h-3l1-6h-2l-1 3-6 1-16 24-26 36-11 14-7 9-4 7-4 2 2-5 22-33 15-24 12-19 7-11 15-23 13-22 9-14 17-28 12-22 15-29 11-25 7-15 10-24 8-25 6-26 3-16z",
    fill: "#333D46"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,808)",
    d: "m0 0 6 1 21 9 20 7 3 3 10 7 12 5 23 3 24-2 13-3h6l6 3 28 2 7 1 32 2 8 6 1 9 2 4v5l4 5 12 6-1 2h-7v-2l-7 1-2-2-12-4-3-5-13-5-18-6-9-4-8-3-11 1-8-7-5 1-3 2-13 1-4 3-5 1 2 4 4 1 2 4 9 1 3-1 3 3-1 2h-17l-3-2-7 1h-11l-50-7-47-9-45-9-35-6-43-6-36-3h-38l-9-3-1-2 6-1 79-4 99-7z",
    fill: "#FAFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(990,685)",
    d: "m0 0 2 3v17l-3 21-5 15-9 24-5 22 1 34-2 14-4 8-6 8-3 5-1 4 4-2 13-9 8-3 12-1h13l14 2 10 3 9 7 12 12 6 9 3 7-1 4-5-5-15-12 7 11 5 9 1 4v14l-3 7-1 5h-2l-1 4-2-1 3-10v-13l-5-14-7-12-10-9-13-6-4-1h-18l-11 4-11 8-9 10-5 13-1 5v19l2 11-6-5-4-11-1-10v-17h-3l1-3h4l-1-2h-7l-1 4-2-1-1 6-5 13-4 13h-2v7l9 4h5l2-4h7l12 14 10 8 10 6-1 2h-2l-1 5-7 5-3-1-13-7-18-14-16-9-6-7-5-7-1-11 1-3-5-1-2 6-2 4-22 3h-26l-20-2-3-2v-5l-2-1h5v2l24-8 8-4-5-2 1-2 11-6 3-1v-2l5-4 13-3h19l15-4 5-5 8-12 9-9 7-5 5-8 3-16 8-38 5-20 6-19 7-23 4-17z",
    fill: "#060506"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,1026)",
    d: "m0 0h1l2 23 5 23 7 21 14 35 18 39 16 33 15 26 24 40 15 23 11 17 12 19 11 17 12 21-1 2-8-12-7-10-24-36-2-5-2 2 3 4 1 5 5 8 1 8 2 1-2 2-9-10v-2l-4-1-9-10-10-13-9-10-4-5-3-5-5-6-4-6v-3l-4-2-4-6-1-3-3-3v-3l-3-1-1-4h-2l-1-4-3-1-3-6-3-5-2-3v-3l-4-2-5-11-6-13v-5l-1-3 1-2-2-1-3-5-3-6-7-8-2-5h-2l-3-4v-2h-2v-2l-3-1-9-12v-2l-4-2-7-9v-2h-2v-3h-2l-3-6-2-3-1-9 7-2 2 1v2h3l1-9h2l1-6 1-5-1-6 3-3h2l1-2v3h3l2 5 2 7 3 8 2-4v-6h-2l-3-15-3-16-1-6v-13h4z",
    fill: "#333D46"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,505)",
    d: "m0 0 4 2 1 3 2-1 8 13 6 11 7 10 3 1 12 23 6 10 3 6 5 9 7 12 6 12 4 7v2l6-2-1 9 1 3 4-3 3 7 3 3v2l4 2 3 3 4 7 10 9 13 1 3-1 3-8 6 2 8 11 6 12 3 9-1 2h2l11 39-1 3 1 35v28h-2v2l-5-1-22-12-22-11-1-17-1-26-1-2-1-17-3-9-1-10h-2l-1-6-5-13v-3h-2l-8-13-6-11-3-5-3-1v-2l-4-1-3-3v-2h-2l-5-11-21-42-6-10-11-20-12-22-9-17-3-5z",
    fill: "#444C54"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1298,594)",
    d: "m0 0 4 1v5l-2 1-1 8-9 15-10 18-12 25-9 27-4 19v39l1-7 2-1-1 25-1 6-13 5-5 3-10 3v2l-15 8-7 3-5 2-1-12v-48h1l1 10 4-2 1-2 3-1 3-7 2-4v-1l-1-7 3-3-1-9 3-9 2 1 1-5 3-8-1-4 2-5 1-7 3-1 2-6 3-1-1-4 4-1v-4l3-1 1-3h4l1-5h4v5l4-5-1-5h2v2h2l1-5 3-3 2-8h2v-2h2v-5l2-2 1-2h2l1-3v-2h2l2-5 5-6 2-5 3-1v-2l5 1 2-3h3z",
    fill: "#454D55"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1199,733)",
    d: "m0 0h1l1 56 1 11 7-4 8-3 9-5h2v-2l14-6 9-4 5-1 2 9-8 5-26 12-12 5h-2v2l5 2 18 11 14 11 12 11 5 7 3 9v9l-3 10-2 1-1-8-4-8-9-10-11-9-16-9-17-7-11-3h-16l-16 4-18 8-12 11-7 8-4 5-2-7-1-19 3-10 7-9 9-11 11-12 9-10 14-14 7-8 5-5 4-3 1 2 6-8 3-8h2z",
    fill: "#060607"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1101,658)",
    d: "m0 0 6 1-2 11-9 32-2 5 19-5 53-10 20-5 13-5 8-5-1 5-10 27-5 12h-2l2-6 1-2-8 3-50 9-21 6-12 5-11 7-13 11-7 10-7 14-3 10 1 4-8-6-7-8-6-11-1-4v-13l4-10 6-9 5-6 12-9 8-5 11-3-3-5-7-5v-2h-2l-9-11-8-8h3l26 26 2 1 2-10 6-20 5-15z",
    fill: "#060507"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,658)",
    d: "m0 0h4l10 31 3 11h2l12-13 14-13 5-5-2 6-15 16-7 7-8 7v2l12 5 11 9 10 11 6 10 3 11v9l-3 13-9 13-9 7-2-1 4-4-1-4-6-19-6-11-6-7-15-11-19-9-22-6-36-8-7-4-6-5h-4l-1 4h-2v-2h-2l1 6-3-4-9-25-4-9 1-2 13 9 12 5 28 6 44 7 16 4 3 1-5-12-6-26-1-9zm-93 48 1 2z",
    fill: "#060506"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(639,484)",
    d: "m0 0 6 1 15 9 7 7 8 7 13 13 5 4 7 8 15 15 10 11 7 8 7 9 8 11 11 13 9 11 11 10 11 9 12 12 12 21 1 4-1 2-9 3-1 5 2 5 3 3-2 1-10-6-8-5-2-4-2-5-4-1-6-8-5-4-5-7v-2l-3-1-6-8-7-9-5-3-12-16-14-17-13-15-14-18-13-18-24-34-8-11-6-9z",
    fill: "#FEFDF5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 708)",
    d: "m0 0 2 1 14 36 6 18 4 18 1 13-2 1-1 5v11l1 17v15l4 2 15 15 8 11 8 18 1 7v9l-3 12-7 4-1 3-6 1-2 5-8 8h-2v2l-11 9-8 5-10 3h-16l-12-3-12-7-13-11-9-11h-7l-2 4-8-1-7-4 1-7h2l1-6 5-16 4-10h2l1-3 7-1 1 3-4 1-1 2h3l2 27 4 11 15 14 13 8 8 3 9 2 12-1 13-5 14-10 10-10h2l1-4h2l1-7 2-5v-14l-4-10-7-11-2-4 9 6 9 8 3 3-1-5-4-8-7-9-11-11-8-5-12-3-10-1h-13l-12 1-10 4-13 10-3-1 1-4 3-5 9-13 2-7 1-18-1-26 2-9h1l1 14 2 5 9 4 13 2 12-1 10-5 6-7v-17l-9-27-6-15-7-21z",
    fill: "#1D1E23"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(955,547)",
    d: "m0 0 1 4-1 5h2l-1 6-1 4 3 7v8l-1 2 2 1 2 8 3 5 1 5 1 3h2v3l5 1 3 5 4 3 1 8v3h2l3 4 1-5 1-9h1l1 51 2 14v5h-1l-1 5h-1v-23h-2l-2 9-4 11-3 7-7 3-3 7-5 15-2 9-3 7-4 1-1 2-2-2-1-7-4-1-7-8-4-2-12-9-7-3 4-5h2l2-4 8-8 6-8h2l2-5 9-7h2v-2h2v-3l3-3h3l-7-8-11-14-5-5v-2l-4-2-2-5 4 2 11 9 6 5 8 11 4 4v-10l-4-11-8-13-3-9 4-3 1-3h-8l-1 14 3 9-4-3-2-6-1-9 1-1 1-7h5l-3-2v-2l5 1 1-3-3-1v-2l-3-1 3-7v-4l5-36z",
    fill: "#BCB9B3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(996,203)",
    d: "m0 0 4 2 6 36 6 39 16 97 6 30 3 13-1 4-4-1-2-10-5-21-2-10-3-19-3-14-3-11-1-11-2 1v11l-3 14v16l-3 7-3 10h-1l-1-20-1-8 2-25 1-6v-19l-1-28-2-23-2 115-5-2-5-7-1-4-1-6h-2l-1-2-4-1-2 4-1 5h-2v2l2 1-2 9-2 1-1 7-1 3-2 14-2 8-2 17-2 13-2-2-1-10 4-24 7-36 13-74 8-46 5-37z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,449)",
    d: "m0 0 4 4 8 12 5 10 7 10 13 19 11 15 14 20 13 18 12 15 9 11 9 10 8 10 14 18 12 16 14 18 2 5-6-1-4 7-5 1-11-1-11-10-3-4v-3l-3-1-5-6v-2l-4-2-2-5-3 3-2-4 1-8-5 1-6-11-8-15-7-12-6-11-15-28-13-25-12-21-17-29-12-19v-4l4 2 1 1z",
    fill: "#A6A6A2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(994,1395)",
    d: "m0 0 4 5 1 5 1 6-1 7v6l1 1 1 21-1 2 1 4 1 18 1 7v28l-1 8 1 9 1 4h-2l2 10-1 2h2l1 13 1 2 2 27v9l-2 6-1 2h2l1 6-3 6v12l1 7v10l1 2-2 12-1 11v15l1 4-3 19-3 11-4 1-2-5-4-24v-15l-1-28v-53h-2l1-8 1-18v-41l-1-21-3-1v-10h4l1-17-1-10 1-6-1-7 1-5 1-9 1-2h-2l1-9-1-5 2-10v-8z",
    fill: "#444C54"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1358,493)",
    d: "m0 0 2 2-6 9-8 13-10 22-10 19-8 16-14 26-4 7-2-1 2-6h2l-1-3 1-2-4 1-6 4-4-2v2l-3 2-3 7h-2l-2 4-3 7-4 2v4l-2 2-1 3h-2v2h-2v5l-2 5-3 1-1 5h-2l-1 1 1 3-5 5-1-2 1-4-4 1-1 4h-4l-1 4-5 5h-2l1 4-3 2-2 5-3 3v8h-2l1 7-4 8-1 4h-2l-2 10 1 7-2 3h-2l2 6 2 1-4 5v2h-2l-2 6h-3l-1 3h-3l-1 2-1-1-2-15-2 3-2-1 3-9 15-43 8-16 7-11 13-19 13-17 8-11 9-12 11-13 13-16 13-17 14-19 6-8 4-4h3l4-5 6-9h2l1-4 4-4z",
    fill: "#333C45"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,1063)",
    d: "m0 0 1 2-2 6h2l-2 12-5 17-10 24-8 15-11 23-1 8-5 10h-2l1 4 8-4 3 1-2 5-4 12h-2l-2 6-2 4-4 3-4 8h-2v3h-2l-1 6-6 9-11 18-1 4 5-5 9-13 12-16 5-7 6-11 7-10 4-5 1 2-6 12-8 14-10 15-3 5-4 5-3 7-10 13-9 12-12 14-4 6h-2l-1 4-4 4h-3l1-6h-2l-1 3-6 1-16 24-26 36-11 14-7 9-4 7-4 2 2-5 22-33 15-24 12-19 7-11 15-23 13-22 9-14 17-28 12-22 15-29 11-25 7-15 10-24 8-25 3-12z",
    fill: "#444C54"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,1323)",
    d: "m0 0 4 2v15l-3 7h2l1 4v13l1 5v29l-1 3 3 1v13l1 10-1 7 2 18v11l4 1 2 4 2 12 4 5 2 9 1 17-1 10 1 5-1 5h-2v11l-4 10-2 3-1 11 2 7-1 14 1 6h-2l1 3v11l-1 14-1 10v6l-2 3h-2v-11l-1-10v-8l3-6v-6h-2l2-10-1-22-1-13-1-1-1-10 1-3h-2l-1-12v-4l-1-9 1-15v-25l-2-13v-10l-1-3 1-3v-19l-2-1v-10l1-4-2-8v-2l-3-3-1 7-1 12-1 4 1 9-2 4h2l-1 14-1 3 1 7-1 8 1 9-1 15-2 1-3-1 1 10 3 1 1 25v34h-1v-11l-4-2 2-6-4-1-1-2-6-1-1 4-2-6v-10l-4-2-1-12 1-3 2-1 3-7 1-4h2v2h2l-2-11h-2l1-6h3l-1-7 2-2v2l3-1 1-15 3-1-1-7-1-5 1-5h2l1-9h-2l1-10-2-1 1-4 1-12v-3l2-34 2-4 1-23 1-3 3-3-2-3v-5z",
    fill: "#333D46"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(959,496)",
    d: "m0 0 2 3-1 16-3 18v3l-1 11-3 17-3 24 1 2-3 3-1 4 2 1v2l4 1-2 4-5-2v2l4 2-4 1-2-1v7l-1 2 2 10 2 5-1-4-1-3 1-15 9 1-1 4-3 3 4 9 9 16 2 7v10h-3l-8-11-4-5-11-9-8-6 4 6 5 5 9 10 7 9 4 4v2h-3l-1 3h-2v3h-2v2l-11 8-2 4h-2l-2 5-3 1-2 4-13 13-5 1v-4l17-16 12-13 1-4-9 10-8 7-7 7-6 7-2-2-8-27-5-16 8-5 6-5 10-14 9-17 8-21 6-21 7-34 6-42z",
    fill: "#F5F4F4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,821)",
    d: "m0 0 10 2 5 2 3 3 10 7 12 5 23 3 24-2 13-3h6l6 3 28 2 7 1 32 2 8 6 1 9 2 4v5l4 5 12 6-1 2h-7v-2l-7 1-2-2-12-4-3-5-13-5-18-6-9-4-8-3-11 1-8-7-5 1-3 2-13 1-4 3-5 1 2 4 4 1 2 4 9 1 3-1 3 3-1 2h-17l-3-2-7 1h-11l-44-6-5-2v-2h-5l4-2 3 1 3-3h2v-13l-3-6-1-3-4-2-4-4v-2l-7-1z",
    fill: "#FEFCF5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1213,627)",
    d: "m0 0 7 1 2 2v10l-9 19-12 12-16 7-9 5-3 3-11 3-2 1-1 3 2 1-11-1-6-2h-19l-4 1h-9l-3-3 1-6 5-10 5-5 10-3 13-4 23-11 9-6 20-9 15-7z",
    fill: "#FEFDF5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1202,715)",
    d: "m0 0 1 3-5 13-2 6 1 2-4 10-6 7-2-2-6 7-7 6-7 8-15 15-7 8-9 10-8 10-6 9-2 8-1 13h-3l-2-13h-5l-1 9-2 3 3 9 4 10-5 4-2 1h-10l-8-4h-2l1 3h-2v4l15 2h14l5-1v-2h2l-1-7 3 3v2h2l1 4 4 2 5 4-1 3h-7l-10-4v-2l-1 1h-14l-22-3-7-3-12-18-1-2 10-2h2l1-4-7-3-1-1v-5l8-4-5-4-8-7-2-3 1-5 6 5 7 8 3 3v2l11-6 23-14 23-15 12-9 6-5 2-1 1-2h3l2-4 9-7 11-12 10-15 6-10 5-9 4-8z",
    fill: "#F5F5F4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1210,1196)",
    d: "m0 0 5 2 19 13 15 12 11 8 9 7v2l5 2 5 4v2l4 2 4 3v2l4 2 8 7v2l4 2 20 18 10 8 3 2-5-6v-2l-4-2-4-4v-2l-4-2-7-7v-2h4l6 2 7 8 16 17 9 10 9 11 10 11 7 8 6 9 8 8 6 7v2h2l9 11 10 10 7 8 16 16v2l4 1v4l-5-2-10-8-15-14-30-27-11-9-16-15-8-7-8-8-8-7-44-44-8-7-31-31-8-7-14-12-10-9-11-9z",
    fill: "#444C54"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,405)",
    d: "m0 0 5 5 11 18 10 16 17 28 9 15 11 19 12 21 8 15-1 4-7-10-15-25h-3l-2-5-2-1 7 14 10 19 14 25 10 18 10 19 9 17 7 16v2h2l2 2 1 3 4 1v2l4 1 8 13 5 10 3 4v2h2l7 19-1 3h2l3 12 2 7 1 17 1 2 1 33v10h-3l-2-22-3-15-8-28-7-20-9-21-15-30-12-22-16-31-12-22-25-45-12-22-14-27-15-32-14-32z",
    fill: "#212227"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1048,574)",
    d: "m0 0h2l7 23 9 20 8 14 8 11 9 10 7 4 3 1-12 40-2 7-4-2-25-25-10-7 1-5 1-4-4 7-5-2-7-6v-3l9-7 9-9 1-2 3-1 4-5h2l3 7-1 5-3 4h2v-2h2l3-6h2l-1-3-4-1-2-4v-4h-2l-8-14-7-15-2-12v-4l1-7h2l2 4z",
    fill: "#FCFBF3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,816)",
    d: "m0 0h12l23 5 1 2 7 1 6 7 5 5 2 5v9l-1 4-6 4h-1v2l3 1-9-1-42-8-24-5v-1l9-1-1-3-10-2-9-4-12-5-3-2v-3l4-2 28-4z",
    fill: "#FAF3E8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 708)",
    d: "m0 0 2 1 14 36 6 18 4 18 1 13-2 1-3 14-2 26-2 7-2 1-2-1v2l-38 1-5-15-1-6-2-1-2-27v-9l2-9h1l1 14 2 5 9 4 13 2 12-1 10-5 6-7v-17l-9-27-6-15-7-21z",
    fill: "#424A52"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1564,810)",
    d: "m0 0h14l50 4 78 5 54 2 18 2v3l-6 2h-47l-32 3-52 8-25 5h-8l4-5 13-6 10-4 1-3-9-2-18-2-19-4-15-1h-14l-14 1 4-3z",
    fill: "#F9F9F8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,1234)",
    d: "m0 0 2 1-11 11-8 7-25 25-7 8-42 42-8 7-8 8-8 7-10 9-11 9-16 15-11 9-15 13-9 7h-3l1-2 17-17 8-7 7-8 9-10 7-8h2l2-4 2-2 2-5 12-11 14-14 7-8 7-7 8-7 16-15 11-9 10-9 14-10 12-8 10-8 3-3h3v-2l5-3z",
    fill: "#485057"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,846)",
    d: "m0 0 4 1 7 6 11-1 16 6 6 3 13 4 13 5 3 5 15 5 2 1 18 2 13 2 15 4 5 2 6 1v1l-8 1-9-3-31-5-11-2-41-4-70-9-13-2 4-2 7-1 3 2h17v-3l-9 1-5-2-3-4-4-1-2-5 7-2 3-2 13-1z",
    fill: "#F8F2E7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(975,365)",
    d: "m0 0 3 4-1 7 5 1v2h2l2 5 2 3 2 17 2 6 1 32-1 1v15l2 10-1 86-2 59h-1v-110l-4-10-3-4v-3h-3v-3h-2l-1-7h2l-1-9-3-10 2-5 1-6-2-2v-10l1-4-1-3 1-10v-3l-1-11-2-4 1-6-4-1-3 7-2 9-2 11h-1l1-17 3-12 1-10 3-9h2v-5z",
    fill: "#E1DFD9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,449)",
    d: "m0 0 4 4 8 12 5 10 7 10 13 19 11 15 14 20 13 18 12 15 9 11 7 8-2 3 3 8-4-1-5-4 1 3-4 4-4-2-6-9-2-4-2-1-4-7-5-5-4-7-4-6-4-2-12-23-13-24-10-17-16-27-10-16v-4l4 2 1 1z",
    fill: "#BCB9B3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,1063)",
    d: "m0 0 1 2-2 6h2l-2 12-5 17-10 24-8 15-11 23-13 26-10 19-7 12-6 12-3 7-11 20-14 24-12 20-17 25-26 36-11 14-7 9-4 7-4 2 2-5 22-33 15-24 12-19 7-11 15-23 13-22 9-14 17-28 12-22 15-29 11-25 7-15 10-24 8-25 3-12z",
    fill: "#E1E1E0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1249,795)",
    d: "m0 0 3 1 2 3 7 3 4 5 10 7 6 5 1 2 11 2-4 3-14 9-8 5-1 3-4 1h-3l-8-8-17-13-17-11-7-4v-2l7-3 7-1 2-1 6 2h5l1-2 3 1 8-5z",
    fill: "#FEFDF5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1519,825)",
    d: "m0 0 3 1-3 2-7 2-17 5-26 5-40 2-20 3-12 5-8 6-9 7-5 3-1 2 16 1 8 1 14 1 4 2v3l-25 3h-16l-1-2-20-6-5-5 3-2 27-15 12-6 4-1 2-5h2v-2h30l28-1 33-4 25-4z",
    fill: "#FDFCF5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,739)",
    d: "m0 0h6l5 6 4 8 5 15 1 5v11l-6 9-7 5-9 1-7-3-6-7-3-8v-9l4-13 8-15z",
    fill: "#060507"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1096,1095)",
    d: "m0 0 18 1 50 3 21 3 3 1 2-2 4 5 2 5 1 4 4 6-12-2-52-5-37-3-7-1-2-4h-2v-2l2-2 4-3z",
    fill: "#222429"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1193,747)",
    d: "m0 0h1v52h-5-3-7l-15 3-20 8-5-2-7 5-2-1 13-15 15-16 12-12 7-8 5-5 4-3 1 2z",
    fill: "#1D1E23"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,391)",
    d: "m0 0 5 2-1 7 2 4 1 10v3l-1 10-1 2 2 1-1 8v6l2 2-3 12 3 9v9l-1 1v6h2v3h3l4 7 2 5 2 6v63l-1 51h-1v-54h-2l-2-8h2l-2-5 1-9-3-5 5-6 2-3-9-1-1-4 2-4 1-4 2-1v-2l-4-4 2-6-4-2 2 4-3 1-1-2-2 1v-4l-3-3 3-6-2-9 1-3h-2l-1-6 1-8v-4l-2-6 2-2v-9l-1-2v-12l3-7-2-1v-8l-2 1-1 10-1 6-2 6h-2l1 12v29l5 2-4 1v5h-4l1 8-1 2 2 1-1 2-3-1-1-7 1-12v-45l2-13 3-13 2-9 3-7z",
    fill: "#BCB9B3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(994,1522)",
    d: "m0 0h1l1 12 1 15 1 18 2 13 3 63v29l-1 17v16l-3 8h-3l-2-5-1-7-1-20-1-19-1-52 1-31 1-49 1-7z",
    fill: "#A6A6A2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(896,1094)",
    d: "m0 0h5l1 3-1 2 2 1-1 3 4 2-1 3-16 3-44 4-36 5-11 2 2-4 4-10 2-4 7-1 13-2 63-6z",
    fill: "#222429"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1393,455)",
    d: "m0 0 1 2-8 16-16 28-10 17-15 29-14 26-12 22-14 25-12 24-3-1v-3l-2-2 5-12 8-16 16-30 11-19 8-17 10-19 10-16 5-9 7-11 3-5h2l1-4 5-7h2l2-5 3-1v-4h2v-2h2l2-5z",
    fill: "#38414A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1040,541)",
    d: "m0 0 1 3 3 1 5 25 1 11h-3v-4h-2v10l2 1h-3l4 15 10 20 3 4v2h2l3 8h4v4h-2l-3 6h-2v2h-2l2-4 1-5-2-4v-3l-5 5-4 1-2 4-11 11-4 3h-2l3 5 7 5h2l5-9 1 3-3 6v3l7 5-2 1-9-6-7-4-5-4-2-3v-6h-2l2-6 4-6 8-7 12-7h2v-3l-3-1-7-17v-2l-3-1-4-8v-2h-2v2l-6 1v-3l-1 2-5-1-1 3 3 7-3 1-3-5-4-3v-8l-3-8h-2l1 24-2-3-3-14v-8h1l1-15 2-1 3 1 5 28v-13l2-7h5l2 5 3 2 1-4h2l4 4v-31-4z",
    fill: "#E2E0DA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1060,633)",
    d: "m0 0h2l3 7-1 5-3 4h2v-2h2l3-6h2l1-4 2 5 3 5v2l4 2 1 1v6l3 3 5-3-1 7-13 18-2 1v-4h-6l-3 3-10-9-6-4 1-5 1-4-4 7-5-2-7-6v-3l9-7 9-9 1-2 3-1z",
    fill: "#F8F8F7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,812)",
    d: "m0 0h15l19 8-2 2-22-5h-12l-23 5-23 3-4 1 1 3 11 5 11 4 1 1 10 2 2 4-1 1h-14l-44-8-34-5-1-2 23-4 7-3 22-5 13-1 10-3z",
    fill: "#FBFAF2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1725,827)",
    d: "m0 0h47l-3 2-20 4-19 4-8 1-6 1-3-2-2 1-15-1-10 1-22 2-5 1-5-1-3 2-9 2-3-1v2l-9 1-7 2-10 2-11 2-13 2-1 1-13 1-5 2-5 1-16 2-5 1-17 2-13 2 2-4 45-8 60-12 26-5 46-7z",
    fill: "#0A0A0C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(938,881)",
    d: "m0 0h5l1 3-4 1-1 2h3l2 27 4 11 15 14 13 8 8 3 9 2 12-1 13-5 14-10 10-10h2l1-4h2l1-4v7l-6 8-5 5h-2v2l-11 9-8 5-10 3h-16l-12-3-12-7-13-11-9-11h-7l-2 4-8-1-7-4 1-7h2l1-6 5-16 4-10h2l1-3z",
    fill: "#1E1F24"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,1433)",
    d: "m0 0h3l-1 14-1 3 1 7-1 8 1 9-1 15-2 1-3-1 1 10 3 1 1 25v34h-1v-11l-4-2 2-6-4-1-1-2-6-1-1 4-2-6v-10l-4-2-1-12 1-3 2-1 3-7 1-4h2v2h2l-2-11h-2l1-6h3l-1-7 2-2v2l3-1 1-15 3-1-1-7-1-5 1-5h2z",
    fill: "#323C45"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,332)",
    d: "m0 0h1l4 17 3 14 2 10v6h-1l-3-10-1 4-1 6 1 4h-1l-1 12 1 1v44l1 4-1 10-1 35h-2l2 6 1 10v9l-1 5 2 3 2 4-3 10-1 8-4 1-1 3-1 12-2 1v-49l1-18 2-7v-12l1-23v-40l-1-21 1-25v-19z",
    fill: "#E2E0DA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,500)",
    d: "m0 0 4 5 1 3v5l1 2v3l2 3v6h2l1 19v33l-2 1-4-1-4 18-2 3-1-3-2 2-1-20h-1v-25l1-33 3-18z",
    fill: "#FEFDF6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,1026)",
    d: "m0 0h1l2 23 5 23 7 21 14 35 18 39 16 33 12 21-2 1-10-15-3-6-7-11-15-27-3-6-1-4h-2l-4-8-3-5-3-7-3-5-2-11-5-13v-3l-3-1-4-13-1-5h-2l-3-15-3-16-1-6v-13h4z",
    fill: "#4B535A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(922,633)",
    d: "m0 0 4 2 2 5 8 10 7 11 1 6-2 1-3-1v-2l-4-1-9-9-6-7 1 5 3 1 3 3 1 4-4 1h-4l-1 2h-6l-2-3 3-3 1-6-3 3-1 2 1 10h1l10 1 4 3v2h2v2l-7-1-6-1 1 2v12l2 8-6 7-2-2-8-27-5-16 8-5 6-5z",
    fill: "#F5F4F3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1322,1265)",
    d: "m0 0h2v2l4 2 6 7 3 6 19 19v2l3 1 9 11 11 12 7 8 11 11 11 14 10 12 2-2 1 4h6l11 20 9 14-1 2-25-25-7-8-12-13v-2h-2l-9-11-7-7-6-9-11-12-9-11-11-12-3-6-8-9-9-12-5-6z",
    fill: "#09090B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1564,810)",
    d: "m0 0h14l17 2v2l7 1 10 2 29 1 4 1v2l11 3 2 2-1 4-4 3v4l-28 5-9 2h-8l4-5 13-6 10-4 1-3-9-2-18-2-19-4-15-1h-14l-14 1 4-3z",
    fill: "#FCFBF3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,529)",
    d: "m0 0 4 1 6 4 13 11 8 9 7 9 5 10v5l-2 2h-8l3 8 1 4-6-5-9-11-12-15 1-2 3 1-1-6-7-8-5-10z",
    fill: "#FAF4E9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,368)",
    d: "m0 0 2 1 4 13 2 10 7 29 1 2 3 1v12l-3-4-3-7-1-10h-2l-1-3-2 4-1 5-3 7 1 4v4l1 5-2 4 2 2-3 5-1 25 1 4v28h2l1 12-3 8-2-6-2 1-1-8 1-2v-9l-1-11-1-5h2v-40l1-8-1-5v-40l-1-3 1-12v-1l1-10z",
    fill: "#BCB9B3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(826,982)",
    d: "m0 0h2v2h-2l-2 4-11 7-21 7-14 5-12 9-19 12-1 1h-5l-1-2v-7l7-5 5-2 16-9 7-3h-9l2-4 8-3 40-10z",
    fill: "#040405"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1459,870)",
    d: "m0 0h11l-2 2-10 3-28 6-14 1-16 2-9 1-5 1-29 3-11 1-9 1-8 2h-10l-3-1v-3l4-2 35-5 96-11z",
    fill: "#09090B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,580)",
    d: "m0 0 4 2 2 8v7l5 4 2 3v-3l-2-5 2-3 4 1 2-1v3l6-1v-2h2l5 10 3 3 6 14-1 4-15 3-7-2v-2h-2l-3-7-3-9-8-1-2-9-1-16z",
    fill: "#FBF5EB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(991,812)",
    d: "m0 0h15l6 4 3 5v13l-1 2-6 2-8 1h-12l-5-3-3-4v-11l6-7z",
    fill: "#070608"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1064,1121)",
    d: "m0 0h6l2 3h-2l-1 5-8 7-4 5h-2l-2 4-5 7-8 17-12 24h-4l-1-5 4-16 8-18 5-12 7-10 5-4z",
    fill: "#1D1E23"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1103,918)",
    d: "m0 0 8 1 22 3h24l22-2 2 2-7 4-13 5-14 3-9 1h-12l-13-2-10-4-1-4v-6z",
    fill: "#0B0B0D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1374,1333)",
    d: "m0 0 7 6 12 13 7 8v2h2l9 11 10 10 7 8 16 16v2l4 1v4l-5-2-10-8-15-14-30-27-8-7-7-8 4-3-1-7z",
    fill: "#A0A09D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(881,920)",
    d: "m0 0h14l1 1-1 7-3 3-13 4h-23l-16-3-16-6v-3l44-1z",
    fill: "#0A0A0C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,636)",
    d: "m0 0 5 2 9 10 8 10 2 4-1 5-6 5-7 8-10 9-6 5-2-2-1-6v-13l9 1 4 1v-2h-2l-4-4-9-1-1 2-3-7v-6l4-6 2 1-1 6-3 4 7 2 1-3 6-1h1v-3l-3-1-3-3-2-6 4 3v2l3 1 7 8 3 3 3 1v2h4l-1-6-10-15-7-9z",
    fill: "#DFDDD8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,331)",
    d: "m0 0h1l4 16 3 4v21l-5-2-5-7-1-4-1-6h-2l-1-2-4-1-2 4-1 5h-2v2l2 1-2 9-2 1-1 7-1 3-2 14-2 8-2 17-2 13-2-2-1-10 4-24 7-36 2-7h2l1-11 5-5 8-5z",
    fill: "#FEFDF6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(806,756)",
    d: "m0 0 7 4 5 6 6 6 3-3h-2l1-2 7 6 3 4v2l4 2 12 12 9 12-1 2-14-10-10-8-10-5-4 1-5 1-7-3-3-2-3-19v-5z",
    fill: "#444C54"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1193,747)",
    d: "m0 0h1v7l-1 1-1 27-6-1-1 1-12 2-7 1-7 3-6 4-9 8-3-1 7-7 7-8 15-15 7-8 5-5 4-3 1 2z",
    fill: "#444C54"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1083,645)",
    d: "m0 0 7 6 5 4 6 2-12 40-2 7-4-2-18-18 2-5 6 1 1 3 13-18 3-6 3-1-5-2-3 3-1-3 4-3-2-4h-2z",
    fill: "#FAF9F2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,979)",
    d: "m0 0 5 1 5 3 3 3 29 12 17 6 22 12 5 3 2 3-1 5-3 1-4-4-9-4-10-6-11-5-36-13-7-3-5-6-3-4z",
    fill: "#030204"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,1341)",
    d: "m0 0 5 4-5 10-4 5h-2l-2 4-11 11-7 8-4 5h-2l-2 4-4 3h-2l-2 4-12 12 1-6 5-10 5-3 6-10 13-16 4-6 5-3 1-3 3-1 3-6 3-5 1 2 3-1z",
    fill: "#0C0C0E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1210,1196)",
    d: "m0 0 5 2 19 13 15 12 11 8 9 7v2l5 2 5 4v2l4 2 4 3v2l4 2 2 3-2 1v4l3 1 1 4-1 2-4-1-36-36-8-7-14-12-10-9-11-9z",
    fill: "#38414A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(908,1106)",
    d: "m0 0 5 1 2 1 3 10-3 2-6 11-8 16v2l11 9 1 2-5-1-8-6h-4l-5 9-3 4-4-2-1-3 4-10 9-16 7-15 3-12z",
    fill: "#030203"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1040,587)",
    d: "m0 0 2 1 7 17 11 21 1 3h2l3 8h4v4h-2l-3 6h-2v2h-2l2-4 1-5-2-4v-3l-5 5-4 1-2 4-11 11-4 3h-2l3 5 7 5h2l5-9 1 3-3 6v3l7 5-2 1-9-6-7-4-5-4-2-3v-6h-2l2-6 4-6 8-7 12-7h2v-3l-3-1-10-24-4-9z",
    fill: "#EDECEA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1109,834)",
    d: "m0 0 4 1 2 11 3-4 2 17 3 6-2 4-2-1v5h-2v2l-5 2h-14l-13-2-2-1 1-5-1-3 4 1 7 3h10l6-4-3-7-2-6-2-7 2-4 2-7z",
    fill: "#DFDDD7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1192,647)",
    d: "m0 0h5l-1 6-9 10-9 11-8 6-14 7-5 1-3-4 4-6 5-5 15-10 5-5 10-9z",
    fill: "#FCF5EA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(950,606)",
    d: "m0 0h6l7 2 8 3v5l-3 1-5-4-7-1 1 3 7 3v2h-2v-2l-7 1 6 10 4 7 3 5 2 10v7l-3 8h-3l-5-5-9-10-8-10-4-4v-2l-4-2-2-5 4 2 11 9 6 5 8 11 4 4v-10l-4-11-8-13-3-9 4-3 1-3h-8l-1 14 3 9-4-3-2-6-1-9 1-1 1-7 6 1z",
    fill: "#1A1C20"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,1105)",
    d: "m0 0h21l48 4 26 4 12 3 4 5-12-2-52-5-37-3-7-1z",
    fill: "#E5E5E2"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,670)",
    d: "m0 0h2v6l-5 11-12 36-9 22-6 5 2 1v3l-5-1-4-13-7-10-5-6 1-2 8 9 3 1 3 8 5-3 3-8 3-14 4-9 3-7 7-2 3-10z",
    fill: "#E0DFD9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,1104)",
    d: "m0 0h12l1 2-1 2-16 3-44 4-36 5-11 2 2-4 7-3 19-4 32-4z",
    fill: "#E8E7E5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,500)",
    d: "m0 0 4 5 1 3v5l1 2v3l2 3v6h2v8l-3 3-2-4v-3h-2v19l-4 10-2 8-1 10-2 1v-25l1-33 3-18z",
    fill: "#FCFCFB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1268,1096)",
    d: "m0 0 3 3 2 5 2 2 1 3 1 2 1 5 3 7h2l2 6-1 2h3v2h2l18 38 12 25 10 18 4 8h-2l-10-15-3-6-7-11-15-27-3-6-1-4h-2l-4-8-3-5-3-7-3-5-2-11-7-18z",
    fill: "#4C545B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 708)",
    d: "m0 0 2 1 14 36 6 18 4 18v6h-2l-1 5-3 7-7 8-8 2-1-1h-20l-15 1-3-13v-9l2-9h1l1 14 2 5 9 4 13 2 12-1 10-5 6-7v-17l-9-27-6-15-7-21z",
    fill: "#A8A8A4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,918)",
    d: "m0 0h1v7l-6 8-5 5h-2v2l-11 9-8 5-10 3h-16l-12-3-12-7-13-11-9-11v-3l3 1 5 6 8 7 9 7 11 6 13 3 12-1 13-5 14-10 10-10h2l1-4h2z",
    fill: "#F3F2F1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1091,846)",
    d: "m0 0h6l6 5 7 11 1 4-5 4-2 1h-10l-10-5-3-3-1-4 3-7 5-5z",
    fill: "#0C0C0E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(236,827)",
    d: "m0 0h30l36 3 5 5-2 2-9 1-1 1-12 1v-2l-16-1-25-6-11-2v-1z",
    fill: "#09090A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(920,863)",
    d: "m0 0 1 2-3 6-3 4v1l-9 2h-19l-15 3-1 3h-2v2l-10 6-4 2 4 2 3 1-19 8-12 4h-4v-2l-6 1v-2l10-4 3-2h3v-2l16-9 13-8 12-5 23-1 1-1h5l2-4 7-4z",
    fill: "#ACACA8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,983)",
    d: "m0 0 4 1-2 4-7 7-6 8-2 1-1 5-2 1-3-6-5 1-4 2-4-1-7-8-5-9 1-3 1-2 6 1 14 9 5 1 8-4z",
    fill: "#1F2025"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1212,805)",
    d: "m0 0 2 1 3 3 2-2h5l8 4 5 2 8 7 10 8 4 2 3-2 7 1-2 4-6 7h-3l-1 2-12-11-14-10-19-12-2-1v-2z",
    fill: "#F8F7F7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,1063)",
    d: "m0 0 1 2-2 6h2l-2 12-5 17-10 24-8 15-11 23-7 14-1-3 5-11 1-6 7-16 7-15 10-24 8-25 3-12z",
    fill: "#A7A7A3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1127,800)",
    d: "m0 0 2 1-18 14-13 10-11 10-15 9-7 1-2-2v-5l8-4-5-4-8-7-2-3 1-5 6 5 7 8 3 3v2l11-6 23-14z",
    fill: "#0A0A0C"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,318)",
    d: "m0 0 5 1 2 2 2-1 1 5-2 5-2-1-1-2-1 1v11l-3 14v16l-3 7-3 10h-1l-1-20-1-8 2-25 2-7 2 1-1 2 2-1 2-4-1-5z",
    fill: "#F9F8F1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1116,876)",
    d: "m0 0 2 2h-3l1 2 9 3h7 3l10 7 14 9 9 6 12 5 5 4-5-1-9-3-4-2-10-2-17-7-8-5v-2h-3v-2l-5-1-3-4-7-2-3-1v-2h-10v-1l12-1z",
    fill: "#444C54"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(990,685)",
    d: "m0 0 2 3v17l-3 21-5 15-9 24-5 22h-1v-8h-2l1-8 8-28 7-21 5-21z",
    fill: "#0C0C0E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1337,1229)",
    d: "m0 0 4 5 17 29 17 26 11 17 12 19 11 17 12 21-1 2-8-12-7-10-24-36-15-24-16-28-7-12-4-8v-2h-2z",
    fill: "#DAD8D3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(994,1623)",
    d: "m0 0 4 3 1 13 1 34v30l-1 9-3 1-3-38v-45l1-2-1-3z",
    fill: "#E2E0DA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1393,455)",
    d: "m0 0 1 2-8 16-16 28-6 10-5 1v3h-2l-1 4h-2l-1 4h-2l-1 4-4 1-1 3-1-2 9-16 10-16 6-9 2-4h2l1-4 5-7h2l2-5 3-1v-4h2v-2h2l2-5z",
    fill: "#374049"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,606)",
    d: "m0 0 6 1 3 5 3 11h2v2h2l4 4 1 4-2 2h-2l-4 3h-2l2 6-5-1-3-1-5-13-3-11 1-4 1 2 2-1-2-6z",
    fill: "#FEFDF5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,853)",
    d: "m0 0 2 3 1 7 2 4 1 3h-2v4l15 2h14l5-1v-2h2l-1-7 3 3v2h2l1 4 4 2 5 4-1 3h-7l-10-4v-2l-1 1h-14l-22-3-7-3 1-4-3-8v-6l6-1z",
    fill: "#DEDCD6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,648)",
    d: "m0 0 1 2-3 7-4 6h1l5 1 4-8h2l4 5 5-3-1 7-13 18-2 1v-4h-6l-3 3-4-5 2-2 1-9 3-7h2l2-5z",
    fill: "#F2F2F0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,912)",
    d: "m0 0h1v10l-2 8-7 8-14 10-16 9-12 5-4 1h-7l-2-3v-5l2 1v4l24-11 17-10 10-7 6-8 3-6z",
    fill: "#ECEBEA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,1262)",
    d: "m0 0v3l-9 12-12 14-4 6h-2l-1 4-4 4h-3l1-6h-2l-1 3h-5l2-5 4-3h2l-1-3 4-3 2-4h2v-2h2l-1-5 5-1 1-5h8l2 1 3-1v-2h2v-3z",
    fill: "#333D46"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(902,915)",
    d: "m0 0 2 1 4 7 7 9 16 9 14 11 11 7 8 3-2 2-9-1-13-7-15-10-16-10-5-5-2-11z",
    fill: "#E7E7E5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1026,993)",
    d: "m0 0 5 1-6 15-10 16-11 23-2 1v-11l4-13 6-12 5-6 5-9z",
    fill: "#1D1E23"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(805,767)",
    d: "m0 0h1l2 14 6 3 8 1 1-2 6 1 11 7 10 8-3 1-5-2-5-3-6 1-4-1h-9l-11 2-2-23z",
    fill: "#1D1E23"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,449)",
    d: "m0 0 4 4 8 12-1 3 8 14-1 3 3 5h3l3 5 1 3 5 8v2l5 9v4h2l3 7v3h-2l-12-22-14-24-17-28-2-3v-4l4 2 1 1z",
    fill: "#D5D3CE"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,252)",
    d: "m0 0h1l2 16 1 12 1 28v22l-1 3-2 27-1 5h-1z",
    fill: "#181A1E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,572)",
    d: "m0 0 1 3 1 4 2 5 2 1-1 2 3 1 14 28v3l4 2 1 7 4 2 9 15-1 2-2-3-3-1v-2l-4-1-3-3v-2h-2l-5-11-21-42-3-4 1-2z",
    fill: "#333D46"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,1330)",
    d: "m0 0h2l1 7h-2v2l-5 4-1-1-2 4-5 1 1 3-4 1-3 4h-2l-1 3-8 7-28 28h-2l-2 4-2-1 6-8 5-5 16-17 5-6h2l2-4 23-23z",
    fill: "#A5A5A1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(887,877)",
    d: "m0 0h23l-3 2-20 7-24 11h-6l-3-3 13-8h2v-2l5-4z",
    fill: "#454D55"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1038,546)",
    d: "m0 0 3 3v29l-1 2-4-2-3 3-7-7h-3l-1 7v15l-2-3-3-15v-7h1v6h2l1-19 6 2 2 6h6l3 2-1-3 1-7z",
    fill: "#BDBAB4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,733)",
    d: "m0 0 4 5 12 13 9 10 10 10 8 10 2 4-8-6-7-9-3-2 1 1-2 4-7-6-6-7-5-3-2 2-5-17z",
    fill: "#A6A6A2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,652)",
    d: "m0 0 10 10v2h-3l-1 3h-2v3h-2v2l-11 8-2 4h-2l-2 5-3 1-2 4-13 13-5 1v-4l17-16 12-13 6-10v-4l2-2v-2h2z",
    fill: "#DCDAD4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,810)",
    d: "m0 0 5 2 14 8 23 16 8 5-3 3-6 2-9-6-10-8-8-8-8-7-6-5z",
    fill: "#0D0D10"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1068,702)",
    d: "m0 0 2 1v2h5l2 6-8 4-11 8-5 4-2 2-7 1-2 2 1-4 4-6 2-5 6-7 8-4z",
    fill: "#BCB9B3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1202,715)",
    d: "m0 0 1 3-5 13-2 6 1 2-4 10-6 7-2-2-6 7-7 6-7 8-13 13-1-3 5-5 12-13 7-8 9-13 8-13 5-9 4-8z",
    fill: "#A8A8A4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,750)",
    d: "m0 0 3 2 2 6 2 18v8l-3 3-6 2-4-5v-10l5-23z",
    fill: "#1D1E23"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,846)",
    d: "m0 0 6 1 2 3v4l-7-2-4-1-2 12 7-1 5-4 1-2 4 1-1 5-5 5-9 4h-7l-6-3 1-6 7-11 3-3z",
    fill: "#0D0E10"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,821)",
    d: "m0 0h2l6 18 2 5 6 1v1l-12 3-11 7-6 5-3-1 1-4 3-5 9-13 2-7z",
    fill: "#1D1E23"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(994,1589)",
    d: "m0 0h2l1 6 2 17 2 48 1 45-2 7h-2l1-9v-30l-1-47-4-1v3l2 1-2 1-1 16h-1v-36l1-4z",
    fill: "#BDBAB4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1188,763)",
    d: "m0 0h3l1 3v16l-6-1-1 1-12 2-7 1-7 3-4 1 2-1 2-4h3l1-3 4-2 3-3h5l1-2 5-4 2-2 2-4z",
    fill: "#333D46"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1083,645)",
    d: "m0 0 7 6 5 4 6 2-3 10-8 25-2-4 1-3h-2l-1-10-1-4 1-4 4-8 3-1-5-2-3 3-1-3 4-3-2-4h-2z",
    fill: "#F8F8F7"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,611)",
    d: "m0 0 6 2 8 5v29l-2 3v-5h-2l-3-8-4-5-6-11v-2l7-1v2h2l-3-3-5-2v-3z",
    fill: "#DEDCD6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1310,926)",
    d: "m0 0 5 1-6 7-9 7-7 8h-3l-2 4h-3v2l-5 5-4 2-2 4-4 5h-2l-1 3-1-8 5-5 7-6 5-6 7-6 6-7h2v-2h2l2-5 8-1z",
    fill: "#050405"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1067,621)",
    d: "m0 0 3 3 8 13 5 6 1 6h2l3 4-3 3h-2l1 2h2l1-3 5 1v2l-4 3-1-2-5 3-1-3-2 1v-8l-5-5-4-6v-4l-5 1-3-5v-6l2-4z",
    fill: "#FDFDFC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,834)",
    d: "m0 0 3 3 7-2-1 4v8h1l-1 11-3 6-9 1-2-1v-2l1-8 3-18z",
    fill: "#E0DED8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1061,693)",
    d: "m0 0 5 2h5l2-1v2h2v2l4 2 6 5v3l-5 2h-4l-1-4-5-1-2-2-6 5-7 3-7 9-1 4-3 3 1-6 7-13 6-7z",
    fill: "#E0DED9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1329,536)",
    d: "m0 0 5 1-1 8-12 23-9 17-7 3-1-2 2-5 3-5 2-4 3-4 5-10 3-4 4-10 3-7z",
    fill: "#424A52"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1302,818)",
    d: "m0 0 4 1 2 10 1 6-10 4-5 1-11-2-3-1 2-4 3-4h4l1 4h4l4-9 1-1-2-2z",
    fill: "#FEFDF5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,878)",
    d: "m0 0h8l1 1 10 1v2l10 2 5 5 3 1v2h3v2l6 2 5 3 16 7 8 1 8 4 6 2v2h-10l1-2-11-4-24-9-15-7-11-5v-2l-6-1v-2l-10-3z",
    fill: "#1E1F24"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1033,1214)",
    d: "m0 0 4 3 7 21 1 14-5 4-7 4-4-1 1-7 6-12 1-10-4-13z",
    fill: "#050405"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,1160)",
    d: "m0 0h2l-2 6-3 7-3 9-14 27-6 10-6 12-3 7-3 5-1-2v-4l-2 1 2-6 10-16 12-22 15-29z",
    fill: "#D3D2CE"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1361,511)",
    d: "m0 0h2l-2 5-17 33-4 7h-3l-1-4v-5l4-10 3-6 5-4h2l1-4 2-1 1-3h2l1-4h2v-3z",
    fill: "#485057"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,767)",
    d: "m0 0 4 2 8 6 5 3 11 11 11 9 9 8-2 1-11-9-4-2-4 1 7 10-1 2-14-18-5-5-3-5-11-13z",
    fill: "#DEDCD6"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,405)",
    d: "m0 0 5 5 11 18 10 16 7 12-1 3-2-5-4-1v-2h-2v-2h-2l-1-2-4-2-15-33z",
    fill: "#0D0D0F"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,421)",
    d: "m0 0h1v12h3v4h-2l1 12v29l5 2-4 1v5h-4l1 8-1 2 2 1-1 2-3-1-1-7 1-12v-45z",
    fill: "#BEBBB5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,356)",
    d: "m0 0 2 1 1 4 2 1-2 9-2 1-1 7-1 3-2 14-2 8-2 17-2 13-2-2-1-10 4-24 7-36z",
    fill: "#FDFCFB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1337,543)",
    d: "m0 0 1 3-1 1v7l2 1-1 5-12 22-6-1v-6l8-14 8-17z",
    fill: "#474F56"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,864)",
    d: "m0 0 3 1-1 10-4 2h-14l-13-2-2-1 1-5-1-3 4 1 7 3h10l6-4z",
    fill: "#F6F6F5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,899)",
    d: "m0 0h3v2l5 1 2 8v4l10 1v1h-9v2l-2 1v7l-4 1-5-6h-1l-1-13z",
    fill: "#1E2025"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1070,637)",
    d: "m0 0 2 4 4 6v2l4 2 1 1v5l-3-1-2 5-2 4-5-1-2 1 2-6 4-5v-3l-3 6-8-4-1 3-1-5v-3l3 1v-2h2l3-6h2z",
    fill: "#EAE9E7"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,983)",
    d: "m0 0 4 1-2 4-8 8-7 4h-8l-12-6-9-8v-2l6 1 14 9 5 1 8-4z",
    fill: "#E8E7E6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(898,903)",
    d: "m0 0 4 1 2 1v11l-1 4 2 11 2 3-4 2-7-3 1-2h2l-1-2-4-1 1-7-8-1v-1l8-1-2-5 2-1 2-5 2-1z",
    fill: "#3E464E"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(896,928)",
    d: "m0 0 3 1v2l-12 6-8 2h-28l-17-3v-1h8l4-2 10 1h23l13-4z",
    fill: "#DBDAD7"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1040,587)",
    d: "m0 0 2 1 7 17 11 21 1 3h2l3 8h4v4h-2l-3 6h-2v2h-2l2-4 1-5-2-4v-3l-5 5-4 1 6-7v-3l-5 2-13 8-6 7-4 4 1-5 7-8 11-7 5-3h2v-3l-3-1-10-24-4-9z",
    fill: "#989A9A"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,623)",
    d: "m0 0 4 2 6 7 8 11 5 5 5 7 5 5 5 6 1 4 3 5-1 6 1 6-2-2-5-11-8-13-4-7-20-26z",
    fill: "#EBE5DC"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1048,574)",
    d: "m0 0h2l7 23 7 16-1 2-6-10-2-5h-2l-2-3-3 4-2-1-2-12v-4l1-7h2l2 4z",
    fill: "#FCFCFB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1418,1383)",
    d: "m0 0 5 3 21 21v2l4 1v4l-5-2-10-8-15-14-3-3 2-3z",
    fill: "#A7A7A3"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1030,493)",
    d: "m0 0h1l2 19-2 2-2-1-1 7h2l-1-4h2v10l-1 3-5-2-1-1-4 6-1-3 5-15 5-19z",
    fill: "#424B53"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,1585)",
    d: "m0 0h3v26l1 51 2 32v7h-1l-3-17v-15l-1-28v-53h-2z",
    fill: "#424B53"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,651)",
    d: "m0 0 2 1-1 6-3 4 7 2 1-3 11 11 3 2-2 3-9 3h-5l-2-7 9 1 4 1v-2h-2l-4-4-9-1-1 2-3-7v-6z",
    fill: "#B7B5B0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,1113)",
    d: "m0 0 1 3-6 10v8l-21 42-1-3 5-11 1-6 7-16 7-15 5-11z",
    fill: "#B0AFAB"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1207,692)",
    d: "m0 0 3 2-2 9-4 12-4 4-3 7-2 1 1-8 5-11h-3l-1-4 4-11 3 1 1 2z",
    fill: "#F9F5EE"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1268,1096)",
    d: "m0 0 3 3 2 5 2 2 1 3 1 2 1 5 3 7h2l2 6-1 2h3v2h2l7 15-1 2-3 1-15-29-9-23z",
    fill: "#A0A19D"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,379)",
    d: "m0 0 6 5 8 36-1 4-4-1-2-10-5-21-2-10z",
    fill: "#FCFCFB"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1216,949)",
    d: "m0 0 1 3-30 30h-5l-1-4 9-6 15-15 7-5z",
    fill: "#3F4850"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,330)",
    d: "m0 0 2 2 2 5v3l2 1v7l5 12 4 24h-3l-3-5-3-16-3-14-3-11z",
    fill: "#FEFCF6"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,918)",
    d: "m0 0h1v7l-6 8-5 5h-2v2l-11 9-6 4h-2v-3l-2-2 10-6 9-7 9-9h2l1-4h2z",
    fill: "#D1D1CD"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,906)",
    d: "m0 0 2 4-1 10 7 1 3 5-1 1h-5l-5-2-3 1-4 8-12 12-4 1 6-9 6-7 5-5 5-13z",
    fill: "#292E35"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1060,653)",
    d: "m0 0 5 1 2-1 2 2-1 5h-2l-1 6-1 1-1 10-4 1-11-8 1-5 3-4 4 10h2l2-5z",
    fill: "#FAF8F1"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,766)",
    d: "m0 0 3 2 1 8 14 7 10 3 10 5 8 7v2l-6-2-18-10-24-12 1-9z",
    fill: "#A7A7A3"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,888)",
    d: "m0 0 12 1 11 2 5 2h8l7 4 16 8 21 10 3 2-8-1-17-8-10-5-26-10-9-1-13-3z",
    fill: "#404951"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(932,628)",
    d: "m0 0 4 2 11 9 6 5 8 11-1 4-4-1-10-12-7-8-1-3-4-2z",
    fill: "#202227"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,1119)",
    d: "m0 0 8 1-3 3-5 1-1 3-7 4-6 1-5-4v-4l5-1v-3z",
    fill: "#040304"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,842)",
    d: "m0 0 4 5v3l-9 4 1 7 2 5 1 4-2 2-6-8-7-11 10-2h2l1-4-1-3z",
    fill: "#F2ECE3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,710)",
    d: "m0 0h8l1 9-1 4h-3v2h-7l-4-6 1-7z",
    fill: "#A6A6A2"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(740,1034)",
    d: "m0 0 4 1v14l-3 13-3 9h-3l1-7-1-4z",
    fill: "#4D545B"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,866)",
    d: "m0 0 3 3v2h2l1 4 4 2 5 4-1 3h-7l-10-4v-2l-1 1h-14l-9-1v-1l21-1 5-1v-2h2z",
    fill: "#A6A6A2"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,773)",
    d: "m0 0 12 2 2 3 6 2 1 3 5 1 3 4-5-2-7-2-4 2-9-2-4-3z",
    fill: "#333D46"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1077,1104)",
    d: "m0 0h7l-1 3-25 7-19 6-2-1 5-4 8-4z",
    fill: "#CFCDC8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(913,1104)",
    d: "m0 0 9 1 24 6 2 1v6l-16-4-17-6z",
    fill: "#D2D0CB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,922)",
    d: "m0 0 3 1 5 6 8 7 9 7 11 6 5 2v2l-6-1-9-3-9-6-10-9-7-9z",
    fill: "#CFCDC8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,882)",
    d: "m0 0 10 3 12 7 5 5 8 3 4 3 5 1 3 3h-6l-16-7-11-6v-2h-3v-2l-5-1-3-4-4-2z",
    fill: "#333D46"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(995,818)",
    d: "m0 0h7l5 4 1 6h-4l-1-4-1-1-1 5h-15l-1-4 3-1v-2z",
    fill: "#282C32"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(959,496)",
    d: "m0 0 2 3-1 16-3 18v3l-1 11-3 17h-1l1-30 5-36z",
    fill: "#E3E1DC"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1420,398)",
    d: "m0 0 1 2-12 24-5 5-2 1v-2l-4 2 2-5 13-19z",
    fill: "#121315"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(950,606)",
    d: "m0 0h6l7 2 8 3v5l-3 1-5-4-8-1v-2h-8l-1 14 3 9-4-3-2-6-1-9 1-1 1-7 6 1z",
    fill: "#767A7B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,1234)",
    d: "m0 0 2 1-11 11-8 7-10 10-5-1v-2l-2-1 12-8 10-8 3-3h3v-2l5-3z",
    fill: "#39424A"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1013,543)",
    d: "m0 0 3 1v21h-4l-1 22h-1l-1-7v-20l1-12z",
    fill: "#BDBAB4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1630,870)",
    d: "m0 0h6l-3 2-30 11-26 9-8 3h-3v-2l10-4 11-2v-2l18-6 12-5z",
    fill: "#4B5359"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 708)",
    d: "m0 0 2 1 14 36 6 18 3 14v8h-1l-3-16-9-25-10-28z",
    fill: "#32383F"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,505)",
    d: "m0 0 4 2 1 3 2-1 8 13 6 11 2 5h-3v-2l-3-1-4-8h-3l-7-14-3-5z",
    fill: "#333D45"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,449)",
    d: "m0 0 4 4 8 12-1 3 3 5v2h-2l-1-2h-3l-12-19v-4l4 2 1 1z",
    fill: "#DDDCD7"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1323,923)",
    d: "m0 0h2l-1 4-15 11-8 7-7 6-3 7-3 3v-5l5-8 10-11 9-6 8-6h3z",
    fill: "#424B53"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,657)",
    d: "m0 0 6 3 3 5 3 8 3 9 4 9 4 15v8h-1l-3-9-1-10h-2l-1-6-5-13v-3h-2l-8-13z",
    fill: "#333D46"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1337,1229)",
    d: "m0 0 4 5 17 29 13 20-1 3-1-2-2 1-14-25-10-17-4-8v-2h-2z",
    fill: "#A7A7A3"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(929,811)",
    d: "m0 0 5 1 1 2v8l-5 5-5-1 1-3 6-3 1-4-7 2-4 2-6-1-1-4 3-2 9-1z",
    fill: "#1E2126"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1353,494)",
    d: "m0 0 1 3-3 7-3 1-1 4-3 3-6 9h-2l-1 3-3-1-2 4v-3l13-19 7-9z",
    fill: "#202227"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1105,915)",
    d: "m0 0 42 2v1l-21 1v2h15l16 1v1h-24l-22-3-7-3z",
    fill: "#C4C2BD"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,636)",
    d: "m0 0 5 2 9 10 8 10 2 4-1 5-3 2-4-9-9-14-7-9z",
    fill: "#272B31"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1046,683)",
    d: "m0 0h7v2l-4 2 2 11 1 7 1 3-3 1-3 3-3-19-1-7z",
    fill: "#FEFDF6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(660,884)",
    d: "m0 0h16l15 2 15 5 6 1v1l-8 1-9-3-31-5z",
    fill: "#A9A8A4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,949)",
    d: "m0 0 7 2v2l4 2 10 9 5 4 6 8-5-2-6-4-11-10-6-5-4-5z",
    fill: "#333D46"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,852)",
    d: "m0 0 5 2 2 5-1 5-7 1-6-4v-5l4-3z",
    fill: "#E0DEDA"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1060,650)",
    d: "m0 0 1 3-1 4 2 1h-2l1 2v6l-3 7-4-3-2-7 1-6 3-5z",
    fill: "#FDFDFC"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,669)",
    d: "m0 0 1 2-4 6-12 13-8 8-8 6-2-1 1-3h2l12-13 14-13z",
    fill: "#1F2227"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1312,1269)",
    d: "m0 0h4l6 2 7 8 6 6-1 2-3-1v2l-4-2-4-4v-2l-4-2-7-7z",
    fill: "#333D46"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(917,649)",
    d: "m0 0 4 1v3l3 1 3 3 1 4-4 1h-4l-1 2h-6l-2-3 3-3z",
    fill: "#F6F6F5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(997,309)",
    d: "m0 0h1l1 51h1v13l-1 20-1 7h-1z",
    fill: "#B0AFAA"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1080,642)",
    d: "m0 0 3 1 1 6h2l3 4-3 3h-2l1 2h2l1-3 5 1v2l-4 3-1-2-5 3-1-3-2 1v-8l-5-5v-2l5-1z",
    fill: "#FDFCF5"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(897,851)",
    d: "m0 0 5 1 6 2 1-3 1 5h-2l-2 4-7 4-5-1z",
    fill: "#D8D6D1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1052,639)",
    d: "m0 0v3l-12 12-4 3h-2l3 5 7 5h2l5-9 1 3-3 6v3l7 5-2 1-9-6-7-4-5-4-1-6 5-3 7-7h2l2-4z",
    fill: "#999A98"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,932)",
    d: "m0 0 4 1 10 6 11 8 13 10 5 4v2l-4-2-16-11-10-8-13-9z",
    fill: "#3C454D"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1223 1e3)",
    d: "m0 0 8 1 23 12 6 5v2l-6-2-18-10-13-7z",
    fill: "#3F474F"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,830)",
    d: "m0 0 7 1 25 6 13 4 15 6-3 1-23-7-31-9z",
    fill: "#D2D1CC"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,1203)",
    d: "m0 0h11l-2 4-17 5-4-2v-3z",
    fill: "#333D46"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1296,822)",
    d: "m0 0 4 1-3 4-3 7h-5v-5l-7 3-11 7-2-1 12-8 12-7z",
    fill: "#E5E0D7"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1398,1327)",
    d: "m0 0 4 4 13 21 6 11-1 2-8-12-7-10-9-13 2-1z",
    fill: "#D0CEC8"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1253,716)",
    d: "m0 0h1l1 36 1-7 2-1-1 25-1 6-2-3-1-8z",
    fill: "#39424A"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1260,1110)",
    d: "m0 0 4 1 8 11 3 4-1 3-5-1-5-4-3-10z",
    fill: "#454D55"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1063,812)",
    d: "m0 0h16l2 2-1 5h-11l-6-4z",
    fill: "#0C0C0E"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(991,1646)",
    d: "m0 0 3 1v29l2 27 1 8h-2l-2-10-1-20-1-19z",
    fill: "#ADACA8"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(772 1e3)",
    d: "m0 0h5l-2 2-16 8-8 5-7 3-4 2-1 2-1-4 5-3h3l1-3 15-8z",
    fill: "#404851"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,1359)",
    d: "m0 0 2 1-12 16-8 10-4 7-4 2 2-5 16-24 5-3z",
    fill: "#939492"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,1384)",
    d: "m0 0m-1 1m-1 1m-1 1m-1 1m-1 1 1 3-15 13-9 7h-3l1-2 17-17 1 3 5-5z",
    fill: "#565D63"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(917,1126)",
    d: "m0 0 5 3 12 11 6 8 3 2v2l3 1-1 2-5-3-7-7-7-8-9-9z",
    fill: "#030203"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1024,804)",
    d: "m0 0h1l-2 31-2 7-2 1-2-1v2h-5l1-2 2 1-1-3 4-4h2l-1-4 3-15z",
    fill: "#333D46"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,900)",
    d: "m0 0 2 1v11l1 5 3-1 2 11-4-1-5-5-1-13z",
    fill: "#343E46"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,648)",
    d: "m0 0 1 2-3 7-4 6h1l5 1 4-8h2l-2 5-3 5-4 6-3 1 1-5-5 1 2-9h2l2-5z",
    fill: "#909394"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1337,543)",
    d: "m0 0 1 3-1 1v6l-4 7-1 2h-2v5l-4 4h-2l-2 7-2-1 2-6 6-10 8-17z",
    fill: "#333D46"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1655)",
    d: "m0 0h1l1 23 1 4-3 19-2 3v-15z",
    fill: "#414952"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(846,781)",
    d: "m0 0 6 4 10 10-5 2 7 10-1 2-12-16v-5l-5-5z",
    fill: "#EDEBE7"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,1339)",
    d: "m0 0 1 4-4 6 4-1-4 7-3 4h-3l-2 4-3 3-2-1 15-24z",
    fill: "#D9D7D1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1038,1201)",
    d: "m0 0 6 2 11 8 8 8 1 5-3-1-15-15-8-6z",
    fill: "#030203"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,1105)",
    d: "m0 0h21l12 1v1l-19 1-1 1 8 1v1h-11l-7-1z",
    fill: "#C6C5C0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(954,944)",
    d: "m0 0 5 2 3 2v2h6 4l4 3-3 1-1 5h-4l-6-7-8-7z",
    fill: "#1D1F23"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1050,654)",
    d: "m0 0h2l1 5-4 4-3 5-5-2-3-3 5-5 4-2h3z",
    fill: "#F9F8F0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,403)",
    d: "m0 0 2 1-1 17-2 13-2-2-1-10 3-18z",
    fill: "#FDFDFC"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,716)",
    d: "m0 0 2 4 2 17v28l-2 1-1-33-1-2z",
    fill: "#333D46"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1206,699)",
    d: "m0 0 2 1-2 9-2 6-4 4-3 7-2 1 1-8 5-10z",
    fill: "#DCDAD4"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,360)",
    d: "m0 0h2l4 24h-3l-3-5-2-16 2-2z",
    fill: "#FDFCFC"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1216,949)",
    d: "m0 0 1 3-17 17-2-2h2v-2l-2-1 7-7 7-5z",
    fill: "#333D46"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(990,685)",
    d: "m0 0 2 3v17l-1 10-5-2z",
    fill: "#131417"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,815)",
    d: "m0 0 6 5 7 8 4 5h-3l-11-8-4-5z",
    fill: "#121316"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(705,1143)",
    d: "m0 0h2l-1 9-12 24-1-3 5-11 1-6z",
    fill: "#BDBBB6"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,918)",
    d: "m0 0h1v7l-6 8-5 5-7 1 6-7 6-6h2l1-4h2z",
    fill: "#C5C4BF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,900)",
    d: "m0 0 10 2 21 11 8 3v1l-8-1-17-8-10-5z",
    fill: "#3A434C"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(797,733)",
    d: "m0 0 3 4 4 16v6l-2-4-2-3-1 18h-1z",
    fill: "#23252A"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1028,604)",
    d: "m0 0h2v2l4 1 3 3 3 5 4 4-2 2-5-2-9-11z",
    fill: "#E2E0DA"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,948)",
    d: "m0 0 15 5v-2l8 1v2l13 2v1h-16l-12-3-8-5z",
    fill: "#E4E3E0"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1100,927)",
    d: "m0 0 6 2 7 3 13 2 11 1v1h-21l-5 1-8-5z",
    fill: "#CDCCC7"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1052,982)",
    d: "m0 0 2 1-8 11-8 15-3 6-1-3 7-16 8-11z",
    fill: "#3E474F"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,693)",
    d: "m0 0 3 1-3 1v5l-8 8-5-1 2-4z",
    fill: "#EFEFEE"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(920,863)",
    d: "m0 0 1 2-3 6-3 4v1l-13-1v-1h5l2-4 7-4z",
    fill: "#D3D1CB"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(973,761)",
    d: "m0 0 2 1-2 11-3 14h-1v-8h-2l1-8 2-8 1 2h2z",
    fill: "#16181B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(913,667)",
    d: "m0 0 10 1 4 3v2h2v2l-7-1-6-1 1 6-2-2z",
    fill: "#D6D4CF"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1274,596)",
    d: "m0 0h2l1 3-4 6-5 5-3 2-2 7-1-3-2-1 10-14z",
    fill: "#202227"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(940,897)",
    d: "m0 0h1l3 17 2 8h-2l-1 2-3-8-2-16h2z",
    fill: "#404951"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,1660)",
    d: "m0 0h2l1 45-2 7h-2l1-9z",
    fill: "#BDBAB4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1056,676)",
    d: "m0 0 4 2 27 27-2 2-5-5-5-4v-2h-2l-9-11-8-8z",
    fill: "#15171A"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 330)",
    d: "m0 0 1 3-2 27-1 5h-1v-33h3z",
    fill: "#30353C"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1088,691)",
    d: "m0 0 2 1-3 12-4-2-5-5v-2l6-1z",
    fill: "#EDECEB"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1063,716)",
    d: "m0 0h2v2l-8 6-6 5-4 1-2-2 7-7z",
    fill: "#DBD9D3"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1418,1383)",
    d: "m0 0 5 3 9 9v5l-14-12v-2h-2l1-2z",
    fill: "#D7D5D0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(969,651)",
    d: "m0 0h1v7l-3 8h-3l-5-5v-3l3-1 3 2 1-6h2z",
    fill: "#1E2025"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1180,1113)",
    d: "m0 0 9 1 9 3 3 4-12-2-8-1 2-2-3-1z",
    fill: "#CBCAC4"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1059,765)",
    d: "m0 0h3l-4 19-5-5 4-11z",
    fill: "#1D1E23"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1055,627)",
    d: "m0 0h2l-1 3-14 8-7 8-4 4 1-5 7-8 11-7z",
    fill: "#292D33"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1040,526)",
    d: "m0 0h1l2 12v6l-2 1h-3v-18z",
    fill: "#C5C2BD"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,393)",
    d: "m0 0h1v14l-2 22h-1v-34z",
    fill: "#E2E0DA"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1304,939)",
    d: "m0 0 2 1-9 8-3 3-3 7-3 3v-5l5-8 7-8z",
    fill: "#333D46"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,466)",
    d: "m0 0 4 4 10 15v3h-2l-1 3-4-6 1-3-8-14z",
    fill: "#B9B7B1"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1564,810)",
    d: "m0 0h14l17 2v1h-33v-2z",
    fill: "#FDFDFD"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(957,608)",
    d: "m0 0 9 1 5 2v5l-3 1-5-4-7-1z",
    fill: "#1D1F23"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1276,1111)",
    d: "m0 0h2v2h3l7 17-1 3v-2h-3v-4l-2-2-3-5-3-6z",
    fill: "#565C62"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,1104)",
    d: "m0 0h12l1 2-1 2-9 1-3-2-12-1v-1z",
    fill: "#D9D7D2"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1358,1266)",
    d: "m0 0 3 1 10 16-1 3-1-2-2 1-9-16z",
    fill: "#B8B6B1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,931)",
    d: "m0 0 3 1 2-1-2 4-11 11-4 1 6-9z",
    fill: "#1F2126"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 708)",
    d: "m0 0 2 1 10 25v6l-2-1-10-29z",
    fill: "#1C1F23"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,487)",
    d: "m0 0 5 5 5 8v5l-3-1-3-5h-2l-1-5-3-6z",
    fill: "#B8B6B0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,983)",
    d: "m0 0 4 1-2 4-7 6h-2l-2 1v-2l-2-1 9-7z",
    fill: "#DCDBD8"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(928,833)",
    d: "m0 0 5 1 4 2-1 4-3 2-9-6v-2z",
    fill: "#CFCDC8"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,1026)",
    d: "m0 0h1v18l-3-3v-3h-2v7h-1v-13h4z",
    fill: "#414951"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(660,542)",
    d: "m0 0 5 2 7 14-1 3-3-1-8-16z",
    fill: "#343E47"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1409,1372)",
    d: "m0 0 7 6 5 6-6 2-4-4-2-5h2z",
    fill: "#B7B5AF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(896,900)",
    d: "m0 0 5 2-3 5-2 5-1 2-2-1-1-11 2-1 2 1z",
    fill: "#1D1F24"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(850,783)",
    d: "m0 0 4 2 11 10 11 9 2 3-5-2-11-10-8-7z",
    fill: "#AAA9A5"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(915,686)",
    d: "m0 0 2 1 2 8-6 7-2-2-1-6 5-1z",
    fill: "#EEEDEC"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1029,516)",
    d: "m0 0h2v10l-1 3-5-2-2-1 2-7 3-1v2h2z",
    fill: "#454D55"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1026,505)",
    d: "m0 0h3l-2 12-5 12-3 3 1-5 5-18z",
    fill: "#2D3138"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(998,252)",
    d: "m0 0h1l2 16v6l-1 2v9h-2z",
    fill: "#2E3339"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(957,1208)",
    d: "m0 0h5v2l-2 1-2 6h-5l-2-3 1-4z",
    fill: "#030203"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1630,870)",
    d: "m0 0h6l-3 2-19 7h-7l2-2 15-5z",
    fill: "#4B5259"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1390,842)",
    d: "m0 0 2 1-10 6-16 8-5 3-3-1 12-7 12-6z",
    fill: "#E2E0DA"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,813)",
    d: "m0 0h7l1 5-4 2-6-1-1-4z",
    fill: "#0E0E11"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,801)",
    d: "m0 0 7 2h5l1-2 2 3-6 3h-6l-9-3v-1z",
    fill: "#FDFDFC"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(916,673)",
    d: "m0 0 9 1 5 2-5 4h-7z",
    fill: "#4E555B"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1040,587)",
    d: "m0 0 2 1 7 17 7 15h-3l-9-21-4-9z",
    fill: "#BDBAB4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(955,612)",
    d: "m0 0 2 3 7 3v2h-2v-2l-7 1 1 4-4-1-2-6z",
    fill: "#282B31"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(896,928)",
    d: "m0 0 3 1v2l-12 6-2-1v-1h-6v-1l13-4z",
    fill: "#C8C7C2"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(928,687)",
    d: "m0 0 3 1-10 10-8 6-2-1 1-3h2l5-6 5-3z",
    fill: "#24282D"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,1277)",
    d: "m0 0 2 1v4h-2v2l-2 1-2 4-3 3v2l-5 3 2-5 8-13z",
    fill: "#424A52"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1067,920)",
    d: "m0 0 6 1 3 5-1 1h-5l-5-2h-2l1-4z",
    fill: "#1C1D22"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,1203)",
    d: "m0 0h11l-2 4h-8l-5 1-2-1v-2z",
    fill: "#3A434C"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1074,842)",
    d: "m0 0 4 5v3l-7 3-3-1 3-5-1-3z",
    fill: "#F7F1E7"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,912)",
    d: "m0 0h1v10l-2 8-3 3-2-6 5-9z",
    fill: "#CECDC9"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,670)",
    d: "m0 0h2v6l-5 11-2 6h-2l2-10z",
    fill: "#E2E0DA"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(555,1395)",
    d: "m0 0 2 1-2 3h5l-6 7-5 5 1-6z",
    fill: "#2C2E33"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720,1113)",
    d: "m0 0 1 3-6 10-2 6-4 7-1-3 10-22z",
    fill: "#C7C4BF"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1077,1104)",
    d: "m0 0h7l-1 3-11 3h-3v-2l-3-1z",
    fill: "#C1C0BB"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1161,907)",
    d: "m0 0h6l8 4 6 2v2h-10l1-2-11-4z",
    fill: "#1F2126"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,866)",
    d: "m0 0 6 1 8 3 4 2-12-1-13-2 4-2z",
    fill: "#DFDAD2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1275,823)",
    d: "m0 0h6l-2 8-6-1-2-1 2-4z",
    fill: "#FDFDFC"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1127,800)",
    d: "m0 0 2 1-18 14-3 1v-4l16-10z",
    fill: "#24282D"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(971,778)",
    d: "m0 0h1l1 14 2 5 9 4v1h-7l-3-1-3-7-1-13z",
    fill: "#BAB7B2"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,535)",
    d: "m0 0h1l1 11v7l-4-5-1-9z",
    fill: "#FCF9F4"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(972,786)",
    d: "m0 0 2 2 3 5 5 5 6 3-4 1-10-5-2-5z",
    fill: "#E2E0DA"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,766)",
    d: "m0 0 3 2 1 8 2 3-7-2-1-1 1-9z",
    fill: "#A8A8A4"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1052,639)",
    d: "m0 0v3l-12 12-8 5v-3l5-3 7-7h2l2-4z",
    fill: "#454C54"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,819)",
    d: "m0 0 7 2 2 3v4h-4l-1-4-1-1-1 5-3-1z",
    fill: "#3E464F"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1027,396)",
    d: "m0 0 2 3 4 16 4 5-1 4-4-1-2-10-3-13z",
    fill: "#E3E1DB"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(665,1227)",
    d: "m0 0 1 3-4 8-3 5-1-2v-4l-2 1 2-6 2-1 1 3 1-4z",
    fill: "#C7C6C1"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(780,791)",
    d: "m0 0h8l8 7v2l-6-2-10-6z",
    fill: "#B7B5B0"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1049,728)",
    d: "m0 0h2l-2 4-4 6-3-2-2 1 1-6 3-2z",
    fill: "#EBEBE8"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196,706)",
    d: "m0 0h2v2h3l-3 9h-4l-1-4z",
    fill: "#F5F5F2"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1030,648)",
    d: "m0 0 2 1 4-1 2 5-3 3h-3l-1 3v-6h-2z",
    fill: "#DDDBD5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1042,1254)",
    d: "m0 0h2l-2 4-7 5-6 1 1-3z",
    fill: "#BDBCB7"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(946,609)",
    d: "m0 0 9 1-1 4-5 3h-3z",
    fill: "#DFDDD7"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(923,890)",
    d: "m0 0h3l-2 4-5 5-4 5h-2v2l-4 1 6-7 3-3 3-5z",
    fill: "#1D1E23"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,789)",
    d: "m0 0 2 4-4 2-2 4-9 4h-5l4-2 9-6 3-4h2z",
    fill: "#E2E0DA"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,703)",
    d: "m0 0 11 1-2 2-1 4h-2v-2h-2l1 6-3-4zm3 3 1 2z",
    fill: "#3B4046"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1052,901)",
    d: "m0 0 2 2-1 10-4 10h-1l-1-6 4-11z",
    fill: "#3E474F"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(954,649)",
    d: "m0 0 4 1 3 5-1 4-4-1-2-2z",
    fill: "#0D0E10"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1408,1343)",
    d: "m0 0 4 4 9 16-1 2-8-12-3-4z",
    fill: "#B9B7B2"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(697,1160)",
    d: "m0 0h2l-2 6-5 11-4 8h-2l2-6z",
    fill: "#E2E0DA"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1587,886)",
    d: "m0 0 4 1-22 8h-3v-2l10-4 9-2z",
    fill: "#51585E"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,620)",
    d: "m0 0 3 1 5 8v4l-5 5-4 1 6-7v-3l-2-1v-4l-3-1z",
    fill: "#8C8E8D"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,611)",
    d: "m0 0 6 2 3 2v3l-6-1-5-2v-3z",
    fill: "#DEDDDA"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,830)",
    d: "m0 0 7 1 22 5v1h-9l-20-6z",
    fill: "#A0A09E"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1767,822)",
    d: "m0 0 11 1v3l-6 2-14-1v-1l10-1z",
    fill: "#C6C4BF"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,602)",
    d: "m0 0 3 1 1 2 5 1-4 1v7l2 1h-4l-2-4z",
    fill: "#FDFDFD"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,564)",
    d: "m0 0h1v8l-2 16 1 2-4 3v-7l3-15z",
    fill: "#E2E0DA"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,538)",
    d: "m0 0 5 2 6 9 3 6-1 2-13-18z",
    fill: "#F1ECE3"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,1359)",
    d: "m0 0 2 1-10 13-4 1 2-5 2-3 5-3z",
    fill: "#B2B1AC"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,1342)",
    d: "m0 0 2 1-6 11h-3v4l-5 2 4-7z",
    fill: "#282B32"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,846)",
    d: "m0 0 6 1 2 3v4l-7-2-3-2 3-2z",
    fill: "#202328"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(857,792)",
    d: "m0 0 5 2-3 3h-2l7 10-1 2-8-10-1-5z",
    fill: "#D7D6D0"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,647)",
    d: "m0 0 4 3v2l3 1 7 8 5 5-1 2-10-10-6-5z",
    fill: "#5F656A"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,598)",
    d: "m0 0h4v2l4 1-2 4-5-2v2l2 1h-4v-7z",
    fill: "#DBD9D3"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(962,421)",
    d: "m0 0h1v12h3v4h-2l-1 4h-2l-1-7z",
    fill: "#D4D2CC"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,273)",
    d: "m0 0 2 1v13l-1 22h-1l-1-24h2l-1-10z",
    fill: "#040304"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1432,1396)",
    d: "m0 0 7 6 4 4-1 3v-2l-4-1-6-5-1-4z",
    fill: "#BBB9B3"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,1332)",
    d: "m0 0v3l-18 18-1-3 13-12z",
    fill: "#373F46"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,879)",
    d: "m0 0 8 1 9 3 7 3 1 2-11-3-14-5z",
    fill: "#51585E"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,852)",
    d: "m0 0 5 2 1 4-5 2h-3v-6z",
    fill: "#7D7D7D"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1286,582)",
    d: "m0 0h2l-1 5-3 1-1 3-2 1-1 3-4-1z",
    fill: "#23252B"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(964,943)",
    d: "m0 0 4 1 7 4 9 2 1 3-6-1-9-3-6-5z",
    fill: "#BBB9B4"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,922)",
    d: "m0 0 3 1 5 6 3 3-3 3-8-10z",
    fill: "#B1B0AC"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(655,881)",
    d: "m0 0 18 2v1h-20l-12-1v-1z",
    fill: "#D1CFC9"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1083,866)",
    d: "m0 0 4 1 4 3-3 5-5-1 1-5z",
    fill: "#F3F0EA"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,1112)",
    d: "m0 0 2 1 3 3-13 4-2-1 5-4z",
    fill: "#BCBBB6"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1033,937)",
    d: "m0 0h2v3l-10 8v-3l3-6z",
    fill: "#E6E6E4"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1273,652)",
    d: "m0 0 1 2-8 18h-2l1-5 6-14z",
    fill: "#333D46"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,658)",
    d: "m0 0h4l1 5h-2l-1 6-3-1-1-9z",
    fill: "#24262B"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(966,641)",
    d: "m0 0h2l1 4v11l-1-3h-2l-1-4v-7z",
    fill: "#101013"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1020,341)",
    d: "m0 0h2l2 12v5l-2-2-3-8v-6z",
    fill: "#FDFDFD"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(705,951)",
    d: "m0 0 5 3 9 7v2l-4-2-12-8z",
    fill: "#333D46"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1522,861)",
    d: "m0 0h6l-1 3-13 2 2-4z",
    fill: "#101114"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(854,803)",
    d: "m0 0 5 2 5 4 3 4v2l-4-1-4-5-5-5z",
    fill: "#23252B"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,773)",
    d: "m0 0 4 2h-2l1 3-5 2h-5l1-4z",
    fill: "#2D343C"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1207,692)",
    d: "m0 0 3 2-1 6-2-3-5 3-3-1 2-6 3 1 1 2z",
    fill: "#EDE9E1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1088,660)",
    d: "m0 0 1 3-6 9-7 9v-3l8-12z",
    fill: "#A7A7A3"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(699,1164)",
    d: "m0 0h1v6l-5 10h-3l2-6z",
    fill: "#454D55"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(824,923)",
    d: "m0 0h9l2 3-2 1v2l-9-3z",
    fill: "#272B31"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1063,812)",
    d: "m0 0 3 1v2l7-1 1 2-1 3-6-1-5-5z",
    fill: "#1F2126"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(979,345)",
    d: "m0 0h2l4 5v3h-2l-1-2-4-1-2 4-1-3z",
    fill: "#FDFDFD"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1416,1386)",
    d: "m0 0h2v2l4 2v2l4 2 5 6-5-2-11-11z",
    fill: "#ADACA7"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(738,1055)",
    d: "m0 0h1l1 11-2 5h-3l2-13z",
    fill: "#797C7E"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(852,939)",
    d: "m0 0h27v1h-9v2l-11-1-7-1z",
    fill: "#3B444D"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1116,876)",
    d: "m0 0 2 2h-3l1 2 3 2-4 2-4-2v-2h-10v-1l12-1z",
    fill: "#3F4750"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(929,811)",
    d: "m0 0 5 1v5h-8l-1-4z",
    fill: "#222529"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1077,700)",
    d: "m0 0 5 2 3 3v3h-6v-3l-3-2z",
    fill: "#ECECEA"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1053,688)",
    d: "m0 0 5 1-2 4 1 8-2 2-3-10z",
    fill: "#FCF5EA"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,685)",
    d: "m0 0h1l1 9h-6l-1-5 2-2h3z",
    fill: "#F7F1E6"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,1115)",
    d: "m0 0 4 1-5 2 3 2-11 2 2-4z",
    fill: "#C7C6C0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1091,853)",
    d: "m0 0 2 1-2 9-4-2v-5z",
    fill: "#EBE6DE"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(927,677)",
    d: "m0 0 3 1-6 5-5 1-2-2 1-3h7z",
    fill: "#ACABA7"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1259,618)",
    d: "m0 0 2 3-2 3h-3l-1 3-4 4h-2l2-4 5-7z",
    fill: "#23252A"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(967,395)",
    d: "m0 0 1 4-2 9-2 11h-1l1-17z",
    fill: "#E2E0DA"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1243,1061)",
    d: "m0 0h7l1 4-3 3-1-2h-3z",
    fill: "#323C45"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(931,680)",
    d: "m0 0v3l-9 9h-2v-3l8-7z",
    fill: "#ECECEA"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,596)",
    d: "m0 0 2 2 1 9 2 6-2 2-3-7z",
    fill: "#FEFCF4"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,423)",
    d: "m0 0h5l1 1v12l-3-4z",
    fill: "#C0BEB8"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,900)",
    d: "m0 0 2 1v10h-2l1 3-1 7h-1l-1-13z",
    fill: "#404951"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(901,875)",
    d: "m0 0h7l2 2-10 1-13-1v-1z",
    fill: "#AAA9A5"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(948,592)",
    d: "m0 0 4 1 3 4-3 2-6-1z",
    fill: "#262A30"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,471)",
    d: "m0 0 2 4h3l1 7h-3l-4-8z",
    fill: "#D1CFC9"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,405)",
    d: "m0 0 5 5 3 6-1 5-2-2-5-12z",
    fill: "#2C2F35"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(975,984)",
    d: "m0 0 6 1 4 4-4 2-6-5z",
    fill: "#D4D3CF"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(965,952)",
    d: "m0 0 5 2 3 3-2 3-4-2-3-5z",
    fill: "#B4B4B0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(990,685)",
    d: "m0 0 2 3v17h-1l-1-6h-1z",
    fill: "#383F47"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,615)",
    d: "m0 0 4 5-1 7-3-3-2-8z",
    fill: "#FCF5EA"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(959,515)",
    d: "m0 0h1l1 12-2 5h-2l1-13z",
    fill: "#BDBAB4"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,449)",
    d: "m0 0 4 4 5 7-1 5-3-3-4-9z",
    fill: "#E6E4E0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1690)",
    d: "m0 0h1l1 15-2 7h-2l1-9z",
    fill: "#AFAEA9"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(678,963)",
    d: "m0 0 6 2 6 4v2h2l-1 2-13-8z",
    fill: "#424B52"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1175,920)",
    d: "m0 0 6 1-4 4-6 1 2-5z",
    fill: "#26292E"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,665)",
    d: "m0 0h2v2h6l-2 4-3 3-2-3-2-4z",
    fill: "#C4C3BE"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(969,651)",
    d: "m0 0h1v7l-3 8-3-1h2v-12h2z",
    fill: "#333940"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,360)",
    d: "m0 0h1v13l-2 4-1-3v-9h2z",
    fill: "#AAA9A5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1039 1e3)",
    d: "m0 0 3 1-7 14-1-3z",
    fill: "#3A434C"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,953)",
    d: "m0 0 7 1v1l10 1v1h-16l-5-1 4-1z",
    fill: "#D2D0CB"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,901)",
    d: "m0 0m-2 1 2 1-3 4 1 2h-4v-2l-6 1v-2z",
    fill: "#A7A6A2"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,866)",
    d: "m0 0 3 3v2h2l1 4 4 2 1 2-4-1-5-4-2-4z",
    fill: "#414951"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1501,864)",
    d: "m0 0h12v2l-9 1h-5z",
    fill: "#0C0C0E"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,839)",
    d: "m0 0 5 2 3 3h-7l-1 3-2-5h2z",
    fill: "#808282"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(925,668)",
    d: "m0 0 4 2 5 4-2 3-6-1 3-1v-2h-2z",
    fill: "#949593"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,481)",
    d: "m0 0 4 4v3h-2l-1 3-4-6 1-2h2z",
    fill: "#C2C0BA"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1201,1120)",
    d: "m0 0h2v3h-3v4l-5-1v-3l2-2z",
    fill: "#272A2F"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1281,1120)",
    d: "m0 0 3 1 4 9-1 3v-2h-3v-4l-2-2-2-4z",
    fill: "#495158"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,941)",
    d: "m0 0h9l-1 3-3 1h-3-3l-2-2z",
    fill: "#1E1F24"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1064,825)",
    d: "m0 0 5 2 5 6h-3l-7-5z",
    fill: "#101013"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1152,790)",
    d: "m0 0 2 1-5 4-5 5-3-1 8-8z",
    fill: "#374149"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,1585)",
    d: "m0 0h3v13l-2 1v-11h-2z",
    fill: "#414952"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1479,867)",
    d: "m0 0h12v2l-11 2-2-2z",
    fill: "#0B0B0E"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1021,622)",
    d: "m0 0 2 3 1 7-1 2h-2l-2-5 1-3z",
    fill: "#FDFDFD"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(955,547)",
    d: "m0 0 1 4-1 5h2l-1 6-3 2 1-14z",
    fill: "#BDBAB4"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1689)",
    d: "m0 0 1 2h2l-1 10-2 3z",
    fill: "#495158"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1402,1336)",
    d: "m0 0 4 1 3 6-1 4-6-8z",
    fill: "#D3D1CB"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1092,968)",
    d: "m0 0 4 1-5 5-3 1 1-4-3-1z",
    fill: "#1D1E23"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,935)",
    d: "m0 0h8l3 2-1 1h-9l-3-2z",
    fill: "#FBFAF6"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,911)",
    d: "m0 0 7 1 10 4v1l-8-1-9-4z",
    fill: "#38414A"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,837)",
    d: "m0 0h9l5 2v3l-14-4z",
    fill: "#D8D6D1"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1466,833)",
    d: "m0 0h9l-4 3-14-1v-1z",
    fill: "#FDFDFD"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1200,724)",
    d: "m0 0 1 4-3 11-3-1 3-9z",
    fill: "#474F57"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1056,676)",
    d: "m0 0 4 2 11 11-2 2-9-10z",
    fill: "#31363D"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(913,665)",
    d: "m0 0h7l6 2-1 2-10-1z",
    fill: "#ACABA6"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1038,638)",
    d: "m0 0 2 2-8 10-1-3 4-6z",
    fill: "#343B42"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,572)",
    d: "m0 0 1 3-1 4 3 5v2h-2l-5-8 1-2z",
    fill: "#3A434C"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1368,1283)",
    d: "m0 0 4 1 3 5-1 3-3-1-3-5z",
    fill: "#D4D2CC"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(954,944)",
    d: "m0 0 5 2 3 2v2l4 2-3 2-5-5z",
    fill: "#2B2F36"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1068,863)",
    d: "m0 0 4 2 1 5-2 2-4-5z",
    fill: "#F4F3F2"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,813)",
    d: "m0 0 2 1-2 4-4 2-4-1 3-3z",
    fill: "#16171B"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(754,789)",
    d: "m0 0h8l1 2-2 3-6-2-2-2z",
    fill: "#1E1F24"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 708)",
    d: "m0 0 2 1 5 12-1 4-2-3-4-12z",
    fill: "#2F343B"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(988,676)",
    d: "m0 0h1v8l-6 5 3-9z",
    fill: "#FDFDFD"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,651)",
    d: "m0 0 2 1-1 6-5 1 2-6z",
    fill: "#A1A19E"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(966,610)",
    d: "m0 0 5 1v5l-3 1-3-5z",
    fill: "#191B1F"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1048,607)",
    d: "m0 0h2l6 13h-3l-5-12z",
    fill: "#B5B3AE"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1353,494)",
    d: "m0 0 1 3-5 6-4 1 2-4 5-5z",
    fill: "#303840"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1678)",
    d: "m0 0 1 4-2 9h-2l1-11z",
    fill: "#34373C"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1336,1294)",
    d: "m0 0 7 6 1 3-5-2-5-5h2z",
    fill: "#323B44"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,1104)",
    d: "m0 0h12v1h-10v2l-14-1v-1z",
    fill: "#B9B9B4"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(965,955)",
    d: "m0 0 5 5-5 4-3-1-2-2 5-1z",
    fill: "#2E3339"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1085,929)",
    d: "m0 0h2l1 5-3 3-3-1 2-6z",
    fill: "#EDEDEC"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1617,874)",
    d: "m0 0 3 1-1 2-5 2h-7l2-2z",
    fill: "#3F4850"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,873)",
    d: "m0 0h5v4h-6l-2-2z",
    fill: "#FDFDFD"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(994,819)",
    d: "m0 0h3v8l-4-1-1-6z",
    fill: "#3A434B"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(995,818)",
    d: "m0 0h7l2 2-5-1 1 4-2 3h-2l1-7z",
    fill: "#1C1D21"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1078,684)",
    d: "m0 0 1 2 3 1-1 6-4-2z",
    fill: "#FDFDFD"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1101,684)",
    d: "m0 0h3l1 5-5 2-1-2z",
    fill: "#F5F4ED"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(650,530)",
    d: "m0 0 4 1 3 5v2h-3v-2l-3-1z",
    fill: "#363F48"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(960,489)",
    d: "m0 0 3 1-1 6 2 1-1 2-3-1-1-7z",
    fill: "#C2BFB9"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(694,1210)",
    d: "m0 0 2 1-3 6h-2l-2 6-2 1 2-7z",
    fill: "#1D1E23"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1193,1116)",
    d: "m0 0 5 1 3 4-12-2z",
    fill: "#AFAEA9"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1211,992)",
    d: "m0 0 6 1 8 3v2l-5-1-9-4z",
    fill: "#030203"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1311,932)",
    d: "m0 0m-2 1 2 1-2 4-6 3h-2l2-4z",
    fill: "#3E474F"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1182,911)",
    d: "m0 0 10 2 1 2h-12l2-2z",
    fill: "#AAA9A5"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1446,867)",
    d: "m0 0 4 4-10 1-1-2z",
    fill: "#FCFAF2"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(908,851)",
    d: "m0 0 2 4-2 1-1 2-3-3-1 5-2-3 1-4 6 1z",
    fill: "#B2B1AC"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(532,852)",
    d: "m0 0 4 1 1 4-4 1-2-2z",
    fill: "#FCF5EA"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1231,797)",
    d: "m0 0 2 1-3 3-4 1-7 1 2-2z",
    fill: "#E3E1DC"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1027,787)",
    d: "m0 0h2l1 7-2 1-1 5h-1v-9z",
    fill: "#282B31"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1019,748)",
    d: "m0 0 2 2 2 6v5l-2-1-3-10z",
    fill: "#292E34"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,678)",
    d: "m0 0h2l1 10h-1l-1 5h-1z",
    fill: "#C3C2BC"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1060,650)",
    d: "m0 0 1 3-3 4-5 1 3-6z",
    fill: "#FDFCF4"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,468)",
    d: "m0 0h3l3 5v2h-2l-1-2h-3l-2-4z",
    fill: "#E4E2DD"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(969,368)",
    d: "m0 0h2v8l-3 2-1-4z",
    fill: "#FCFBF8"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,1563)",
    d: "m0 0 2 1v6l1 3-4 1-1-5z",
    fill: "#333D46"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(710,1139)",
    d: "m0 0 1 3-4 8h-1v-9z",
    fill: "#A8A8A4"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,1013)",
    d: "m0 0 2 1-8 6h-2l-1 2-1-4z",
    fill: "#6F7476"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1101,911)",
    d: "m0 0h2v3l11 1v1h-9-4z",
    fill: "#333A41"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1230,799)",
    d: "m0 0 7 1v3l-7 1-1-4z",
    fill: "#FCF5EA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1334,518)",
    d: "m0 0h3l-2 6-3-1-2 4v-3z",
    fill: "#272B32"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,491)",
    d: "m0 0 4 4 4 7-1 3-5-8z",
    fill: "#333D46"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023,379)",
    d: "m0 0 2 2 2 8v7l-2-4-2-10z",
    fill: "#E2E0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuriken);
export default __webpack_public_path__ + "static/media/shuriken.29b9f50f8cb647888b742383f2c6038f.svg";
export { ForwardRef as ReactComponent };